<template>
  <!-- 个人荣耀榜 -->
  <div class="body" v-loading="loading">
    <div class="top">
      <img
        style="width: 100%; height: 100%"
        src="https://appfile2.sbgw.cn/hhsbzhxt/a58281618d1b460384de00346d0854a9.png"
        alt="标题背景图"
      />
      <span class="top-left">
        <img class="weather_img" :src="getImageSrc(weatherType)" alt="天气小图标"/>
        <span class="weather_text">{{ weatherType }}</span>
        <span style="padding-left: 8px">{{ temperature }}</span>
        <span style="padding-left: 32px">{{ currentDate }}</span>
        <span style="padding-left: 8px">{{ currentTime }}</span>
      </span>
      <span class="top-right">
        <img
          class="msg_img"
          src="https://appfile2.sbgw.cn/hhsbzhxt/f312640cbd5a480682b5003f32a01742.png"
          alt="今日寄语图"
        />
        <span>今日寄语:</span>
        <div class="top-right-content-wrapper">
          <div class="top-right-content">
            <span v-for="(item, index) in todayMessage" :key="index">{{ item }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </div>
        </div>
      </span>
    </div>
    <div class="content">
      <div class="content-left">
        <div class="card attendance attendance-card" :style="studyCardHeight ? { height: studyCardHeight + 'px' } : {}">
          <div class="card-title-line"></div>
          <div class="card-title">
            <span>
              学习坚持榜
              <span class="card-tip-text">（昨日出勤早到排行榜数据）</span>
            </span>
            <div class="card-title-right" style="display:flex;align-items:center;gap:8px;">
              <div 
                class="content-right-top-item hand active"
              >
                昨日
              </div>
              <!--<div 
                class="content-right-top-item hand"
                :class="{ active: timeRange === '7d' }"
                @click="timeRange = '7d'"
              >
                近7日
              </div>
              <div 
                class="content-right-top-item hand"
                :class="{ active: timeRange === '30d' }"
                @click="timeRange = '30d'"
              >
                近30日
              </div>-->
            </div>
          </div>
          <img
            class="segmentation"
            src="https://appfile2.sbgw.cn/hhsbzhxt/d2e4f540152b4fdeaefecbd99c1ec6cc.png"
            alt="card分割线"
          />
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin-top: -15px;
              position: relative;
            "
          >
            <!-- 统一的轮播指示器 -->
            <div class="table-title-container" style="position: absolute; right: 0%; top: 0; z-index: 10; width: auto;">
              <div class="carousel-indicators" style="justify-content: center;">
                <div
                  v-for="(_, index) in topStudentList"
                  :key="index"
                  class="indicator"
                  :class="{
                    active:
                      carouselStates.attendance.currentIndex.value === index,
                  }"
                  @click="() => handleStudyPersistencePageClick(index)"
                ></div>
              </div>
            </div>
            <div class="attendance-left mr-15">
              <div class="table-title-container" style="opacity: 0;">
                <!-- 占位，保持布局一致 -->
              </div>
              <div class="table-content">
                <dl class="table-header"
                :style="{ height: isScreen ? '3.2vh' : '33px' }"
                >
                  <dt class="rank-column">排名</dt>
                  <dt class="name-column">姓名</dt>
                  <dt class="class-column">班级名称</dt>
                  <dt class="attendance-rate-column">早到(分)</dt>
                </dl>
                <div class="carousel-container">
                  <el-carousel
                    :ref="(el) => (carouselStates.attendance.ref.value = el)"
                    :style="{ height: elCarouselHeight + 'vh' }"
                    v-if="attendanceRateList.length > 0"
                    arrow="never"
                    indicator-position="none"
                    direction="vertical"
                    :autoplay="true"
                    :interval="5000"
                    @change="
                      (index) => handleStudyPersistenceCarouselChange(index, 'auto', 'attendance')
                    "
                  >
                    <el-carousel-item
                      v-for="(itm, i) in attendanceRateList"
                      :key="i"
                    >
                      <dl
                        v-for="(item, index) in itm"
                        :key="index"
                        :class="[
                          'table-row',
                          index % 2 !== 0 ? 'columns-style' : '',
                        ]"
                :style="{ height: isScreen ? '3.2vh' : '33px' }"
                      >
                        <dt class="rank-column">
                          <img class="rank-img" v-if="item.sort == 1 || item.sort == 2 || item.sort == 3" :src="
                          item.sort == 1 ? 'https://appfile2.sbgw.cn/hhsbzhxt/7b60769690a245e2b390af172fb43e76.png' : 
                          item.sort == 2 ? 'https://appfile2.sbgw.cn/hhsbzhxt/7a2e4581bbec41778dc196b47998f142.png' : 
                          'https://appfile2.sbgw.cn/hhsbzhxt/9fa251bd5c7741c7b99de688c2da220a.png'"/>
                          <span v-else>{{ item.sort }}</span>
                        </dt>
                        <dt class="name-column">{{ item.studentName || '--' }}</dt>
                        <dt class="class-column">{{ item.className || '--' }}</dt>
                        <dt class="attendance-rate-column">
                          {{ item.earlyMinutes }}
                        </dt>
                      </dl>
                    </el-carousel-item>
                  </el-carousel>
                  <div v-else>
                    <dl
                      v-for="(itm,i) in itemsPerColumn"
                      :key="i"
                      :class="[
                        'table-row',
                        i % 2 !== 0 ? 'columns-style' : '',
                      ]"
                :style="{ height: isScreen ? '3.2vh' : '33px' }"
                    >
                      <dt class="rank-column">
                        <div class="skeleton skeleton-text"></div>
                      </dt>
                      <dt class="name-column">
                        <div class="skeleton skeleton-text"></div>
                      </dt>
                      <dt class="class-column">
                        <div class="skeleton skeleton-text"></div>
                      </dt>
                      <dt class="attendance-rate-column">
                        <div class="skeleton skeleton-text"></div>
                      </dt>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
            <div class="attendance-right">
              <div class="table-title-container" style="opacity: 0;">
                <!-- 占位，保持布局一致 -->
              </div>
              <div class="table-content">
                <dl class="table-header"
                :style="{ height: isScreen ? '3.2vh' : '33px' }"
                >
                  <dt class="rank-column">排名</dt>
                  <dt class="name-column">姓名</dt>
                  <dt class="class-column">班级名称</dt>
                  <dt class="attendance-rate-column">早到(分)</dt>
                </dl>
                <div class="carousel-container">
                  <el-carousel
                    :ref="(el) => (carouselStates.earlyArrival.ref.value = el)"
                    :style="{ height: elCarouselHeight + 'vh' }"
                    v-if="earlyArrivalList.length > 0"
                    arrow="never"
                    indicator-position="none"
                    direction="vertical"
                    :autoplay="true"
                    :interval="5000"
                    @change="
                      (index) => handleStudyPersistenceCarouselChange(index, 'auto', 'earlyArrival')
                    "
                  >
                    <el-carousel-item
                      v-for="(itm, i) in earlyArrivalList"
                      :key="i"
                    >
                      <dl
                        v-for="(item, index) in itm"
                        :key="index"
                        :class="[
                          'table-row',
                          index % 2 !== 0 ? 'columns-style' : '',
                        ]"
                :style="{ height: isScreen ? '3.2vh' : '33px' }"
                      >
                        <dt class="rank-column">{{ item.sort }}</dt>
                        <dt class="name-column">{{ item.studentName || '--' }}</dt>
                        <dt class="class-column">{{ item.className || '--' }}</dt>
                        <dt class="attendance-rate-column">
                          {{ item.earlyMinutes }}
                        </dt>
                      </dl>
                    </el-carousel-item>
                  </el-carousel>
                  <div v-else >
                    <dl
                      v-for="(itm,i) in itemsPerColumn"
                      :key="i"
                      :class="[
                        'table-row',
                        i % 2 !== 0 ? 'columns-style' : '',
                      ]"
                :style="{ height: isScreen ? '3.2vh' : '33px' }"
                    >
                      <dt class="rank-column">
                        <div class="skeleton skeleton-text"></div>
                      </dt>
                      <dt class="class-column">
                        <div class="skeleton skeleton-text"></div>
                      </dt>
                      <dt class="class-column">
                        <div class="skeleton skeleton-text"></div>
                      </dt>
                      <dt class="attendance-rate-column">
                        <div class="skeleton skeleton-text"></div>
                      </dt>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card offline-examination" :style="examCardHeight ? { height: examCardHeight + 'px' } : {}">
          <div class="card-title-line"></div>
          <div class="card-title">
            <span>学习阶段考试检测
              <span class="card-tip-text">（每个学习阶段考试检测排名）</span>
            </span>
          </div>
          <img
            class="segmentation"
            src="https://appfile2.sbgw.cn/hhsbzhxt/d2e4f540152b4fdeaefecbd99c1ec6cc.png"
            alt="card分割线"
          />
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin-top: -15px;
              height: 89%;
            "
          >
            <div class="offline-examination-left mr-5">
              <div class="table-title-container">
                <div class="title-text">{{ currentYearExams[currentExamIndex]?.title || '' }}</div>
                <div class="carousel-indicators">
                  <div
                    v-for="(_, index) in currentYearExams"
                    :key="index"
                    class="indicator"
                    :class="{ active: currentExamIndex === index }"
                    @click="handleExamDotClick(index)"
                  ></div>
                </div>
              </div>
              <div class="table-content">
                <dl class="table-header"
                :style="{ height: isScreen ? '3.2vh' : '33px' }"
                >
                  <dt class="rank-column">排名</dt>
                  <dt class="name-column">姓名</dt>
                  <dt class="class-column">班级名称</dt>
                  <dt class="score-column">得分率</dt>
                </dl>
                <div class="carousel-container">
                  <el-carousel
                    ref="examCarouselRef"
                    :style="{ height: elCarouselHeight + 'vh' }"
                    v-if="examClassRankList[currentExamIndex]?.length"
                    arrow="never"
                    indicator-position="none"
                    direction="vertical"
                    :autoplay="false"
                    :interval="5000"
                    @change="handleExamCarouselChange"
                  >
                    <el-carousel-item
                      v-for="(itm, i) in examClassRankList[currentExamIndex]"
                      :key="i"
                    >
                      <dl
                        v-for="(item, index) in itm"
                        :key="index"
                        :class="['table-row', index % 2 !== 0 ? 'columns-style' : '']"
                :style="{ height: isScreen ? '3.2vh' : '33px' }"
                      >
                        <dt class="rank-column">{{ item.sort }}</dt>
                        <dt class="name-column">{{ item.studentName }}</dt>
                        <dt class="class-column">{{ item.gradeName }}</dt>
                        <dt class="score-column">{{ item.averageScore }}%</dt>
                      </dl>
                    </el-carousel-item>
                  </el-carousel>
                  <div v-else>
                    <dl
                      v-for="(item, index) in examItemsPerPage"
                      :key="index"
                      :class="['table-row', index % 2 !== 0 ? 'columns-style' : '']"
                  :style="{ height: isScreen ? '3.2vh' : '33px' }"
                        >
                      <dt class="rank-column"></dt>
                      <dt class="class-column"></dt>
                      <dt class="class-column"></dt>
                      <dt class="score-column"></dt>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
            <div class="offline-examination-right" :style="chartHeight ? { height: chartHeight + 'vh' } : {}">
              <div class="title" style="width: 100%; margin-left: 24px;">
                全校得分率趋势图
              </div>
              <div
                ref="offlineExamInationChartRef"
                class="chart-container"
              ></div>
            </div>
          </div>
        </div>
      </div>
       <div class="content-left">
        <div class="card attendance attendance-card" :style="studyCardHeight ? { height: studyCardHeight + 'px' } : {}">
          <div class="card-title-line"></div>
          <div class="card-title">
            <span>
              综合学霸总榜
              <el-tooltip content="综合“早到时间+阶段考试平均分+最近学习积分+最近{x}次统一标准作业平均得分+最近3次单词练习正确率”计算来" placement="top">
                <img class="card-tip-img" src="https://appfile2.sbgw.cn/dcxcx/97295b76b3224abe96cb05d812f82c67.png" alt="tips提示" />
              </el-tooltip>
            </span>
          </div>
          <img
            class="segmentation"
            src="https://appfile2.sbgw.cn/hhsbzhxt/4892fde4041a4aa99575feae11bf6f55.png"
            alt="card分割线"
          />
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin-top: -18px;
            "
          >
            <div class="all-rank">
               <div class="all-rank-cards" style="margin-left: 20px;">
                <!-- 第二名 -->
                <div class="all-rank-item second" v-if="allStudentTop3.length >= 2">
                  <img class="all-rank-img1" :src="allStudentTop3[1].studentAvatar" />
                  <img class="all-rank-img2" src='https://appfile2.sbgw.cn/hhsbzhxt/7a2e4581bbec41778dc196b47998f142.png' />
                  <div class="all-rank-name">{{ allStudentTop3[1].studentName }}</div>
                  <div class="all-rank-class">{{ allStudentTop3[1].gradeName }}</div>
                  <div class="all-rank-score">{{ allStudentTop3[1].progress }}</div>
                </div>
                <div class="all-rank-item second skeleton-item" v-else>
                  <div class="skeleton-avatar skeleton"></div>
                  <div class="skeleton-medal skeleton"></div>
                  <div class="skeleton-name skeleton"></div>
                  <div class="skeleton-class skeleton"></div>
                  <div class="skeleton-score skeleton"></div>
                </div>

                <!-- 第一名 -->
                <div class="all-rank-item first" v-if="allStudentTop3.length >= 1">
                  <img class="all-rank-img1" :src="allStudentTop3[0].studentAvatar" />
                  <img class="all-rank-img2" src='https://appfile2.sbgw.cn/hhsbzhxt/7b60769690a245e2b390af172fb43e76.png' />
                  <div class="all-rank-name">{{ allStudentTop3[0].studentName }}</div>
                  <div class="all-rank-class">{{ allStudentTop3[0].gradeName }}</div>
                  <div class="all-rank-score">{{ allStudentTop3[0].progress }}</div>
                </div>
                <div class="all-rank-item first skeleton-item" v-else>
                  <div class="skeleton-avatar skeleton"></div>
                  <div class="skeleton-medal skeleton"></div>
                  <div class="skeleton-name skeleton"></div>
                  <div class="skeleton-class skeleton"></div>
                  <div class="skeleton-score skeleton"></div>
                </div>

                <!-- 第三名 -->
                <div class="all-rank-item third" v-if="allStudentTop3.length >= 3">
                  <img class="all-rank-img1" :src="allStudentTop3[2].studentAvatar" />
                  <img class="all-rank-img2" src='https://appfile2.sbgw.cn/hhsbzhxt/9fa251bd5c7741c7b99de688c2da220a.png' />
                  <div class="all-rank-name">{{ allStudentTop3[2].studentName }}</div>
                  <div class="all-rank-class">{{ allStudentTop3[2].gradeName }}</div>
                  <div class="all-rank-score">{{ allStudentTop3[2].progress }}</div>
                </div>
                <div class="all-rank-item third skeleton-item" v-else>
                  <div class="skeleton-avatar skeleton"></div>
                  <div class="skeleton-medal skeleton"></div>
                  <div class="skeleton-name skeleton"></div>
                  <div class="skeleton-class skeleton"></div>
                  <div class="skeleton-score skeleton"></div>
                </div>
              </div>
              <div class="table-title-container1">
                <div class="carousel-indicators">
                  <div
                    v-for="(_, index) in allStudentList"
                    :key="index"
                    class="indicator"
                    :class="{
                      active:
                        carouselStates.attendance.currentIndex.value === index,
                    }"
                    @click="() => setCarouselActivePage('attendance', index)"
                  ></div>
                </div>
              </div>
              <div class="table-content">
                <dl class="table-header"
                :style="{ height: isScreen ? '3.2vh' : '33px' }"
                >
                  <dt class="rank-column">排名</dt>
                  <dt class="name-column1">姓名</dt>
                  <dt class="class-column3">班级名称</dt>
                  <dt class="description-column1">各项得分</dt>
                  <dt class="progress-column1">综合得分</dt>
                </dl>
                <div class="carousel-container">
                  <el-carousel
                    :ref="(el) => (carouselStates.attendance.ref.value = el)"
                    :style="{ height: allStudentCarouselHeight + 'vh' }"
                    v-if="allStudentList.length > 0"
                    arrow="never"
                    indicator-position="none"
                    direction="vertical"
                    :autoplay="true"
                    :interval="5000"
                    @change="
                      (index) => handleCarouselChange('attendance', index)
                    "
                  >
                    <el-carousel-item
                      v-for="(itm, i) in allStudentList"
                      :key="i"
                    >
                      <dl
                        v-for="(item, index) in itm"
                        :key="index"
                        :class="[
                          'table-row',
                          index % 2 !== 0 ? 'columns-style' : '',
                        ]"
                :style="{ height: isScreen ? '3.2vh' : '33px' }"
                      >
                        <dt class="rank-column">{{ item.sort }}</dt>
                        <dt class="name-column1">{{ item.studentName }}</dt>
                        <dt class="class-column3">{{ item.className }}</dt>
                        <dt class="description-column1" v-if="item.description && JSON.parse(item.description) && JSON.parse(item.description).length > 0">
                          <!-- {{ item.description || '--' }} -->
                          <div class="description-item red_bar">{{ JSON.parse(item.description)[0] }}</div>
                          <div class="description-item orange_bar">{{ JSON.parse(item.description)[1] }}</div>
                          <div class="description-item green_bar">{{ JSON.parse(item.description)[2] }}</div>
                          <div class="description-item blue_bar">{{ JSON.parse(item.description)[3] }}</div>
                          <div class="description-item purple_bar">{{ JSON.parse(item.description)[4] }}</div>
                        </dt>
                        <dt class="description-column1" v-else>--</dt>
                        <dt class="progress-column1">
                          {{ item.progress }}
                        </dt>
                      </dl>
                      <div class="description-column1">
                        <div class="description-item1 red_bar mr-2"></div><span class="description-item-text">出勤早到</span>
                        <div class="description-item1 orange_bar mr-2"></div><span class="description-item-text">阶段考试</span>
                        <div class="description-item1 green_bar mr-2"></div><span class="description-item-text">学习积分</span>
                        <div class="description-item1 blue_bar mr-2"></div><span class="description-item-text">考点检测</span>
                        <div class="description-item1 purple_bar mr-2"></div><span class="description-item-text">单词练习</span>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                  <div v-else>
                    <dl
                      v-for="(itm,i) in comprehensiveRankItemsPerPage"
                      :class="[
                        'table-row',
                        i % 2 !== 0 ? 'columns-style' : '',
                      ]"
                :style="{ height: isScreen ? '3.2vh' : '33px' }"
                    >
                      <dt class="rank-column"></dt>
                      <dt class="name-column1"></dt>
                      <dt class="class-column3"></dt>
                      <dt class="description-column1"></dt>
                      <dt class="progress-column1"></dt>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card offline-examination" :style="examCardHeight ? { height: examCardHeight + 'px' } : {}">
          <div class="card-title-line"></div>
          <div class="card-title">
            <span>进步之星</span>
          </div>
          <img
            class="segmentation"
            src="https://appfile2.sbgw.cn/hhsbzhxt/3a5bf700ee324949ae0b6059ec4cced0.png"
            alt="card分割线"
          />
          <div style="
              display: flex;
              margin-top: -15px;
              justify-content: space-between;
              position: relative;
              z-index: 100;">
            <div class="early-progress-title">{{ progressStarTitle }}</div>
            <div class="table-title-container" style="margin-top: -3px; position: relative; z-index: 101;">
              <div class="carousel-indicators" style="position: relative; z-index: 102;">
                <div
                  v-for="(ds, index) in availableProgressDatasets"
                  :key="ds"
                  class="indicator"
                  :class="{ active: ds === currentProgressDataset }"
                  @click="() => switchProgressDatasetByType(ds)"
                  style="position: relative; z-index: 103; cursor: pointer;"
                ></div>
              </div>
            </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin-top: -18px;
              position: relative;
              z-index: 1;
            "
          >
            <div class="all-rank">
              <div class="all-rank-cards" style="margin-left: 20px; position: relative; z-index: 1;">
                <!-- 始终显示3个位置：第二名、第一名、第三名 -->
                <!-- 第二名 -->
                <div class="all-rank-item second" v-if="earlyProgressTop3.length >= 2">
                  <img class="all-rank-img1" :src="earlyProgressTop3[1].studentAvatar" />
                  <img class="all-rank-img2" src='https://appfile2.sbgw.cn/hhsbzhxt/7a2e4581bbec41778dc196b47998f142.png' />
                  <div class="all-rank-name">{{ earlyProgressTop3[1].studentName }}</div>
                  <div class="all-rank-class">{{ earlyProgressTop3[1].gradeName }}</div>
                  <div class="all-rank-score">{{ earlyProgressTop3[1].progress }}<span v-if="currentProgressDataset == 'word'">%</span></div>
                </div>
                <div class="all-rank-item second skeleton-item" v-else>
                  <div class="skeleton-avatar skeleton"></div>
                  <div class="skeleton-medal skeleton"></div>
                  <div class="skeleton-name skeleton"></div>
                  <div class="skeleton-class skeleton"></div>
                  <div class="skeleton-score skeleton"></div>
                </div>

                <!-- 第一名 -->
                <div class="all-rank-item first" v-if="earlyProgressTop3.length >= 1">
                  <img class="all-rank-img1" :src="earlyProgressTop3[0].studentAvatar" />
                  <img class="all-rank-img2" src='https://appfile2.sbgw.cn/hhsbzhxt/7b60769690a245e2b390af172fb43e76.png' />
                  <div class="all-rank-name">{{ earlyProgressTop3[0].studentName }}</div>
                  <div class="all-rank-class">{{ earlyProgressTop3[0].gradeName }}</div>
                  <div class="all-rank-score">{{ earlyProgressTop3[0].progress }}<span v-if="currentProgressDataset == 'word'">%</span></div>
                </div>
                <div class="all-rank-item first skeleton-item" v-else>
                  <div class="skeleton-avatar skeleton"></div>
                  <div class="skeleton-medal skeleton"></div>
                  <div class="skeleton-name skeleton"></div>
                  <div class="skeleton-class skeleton"></div>
                  <div class="skeleton-score skeleton"></div>
                </div>

                <!-- 第三名 -->
                <div class="all-rank-item third" v-if="earlyProgressTop3.length >= 3">
                  <img class="all-rank-img1" :src="earlyProgressTop3[2].studentAvatar" />
                  <img class="all-rank-img2" src='https://appfile2.sbgw.cn/hhsbzhxt/9fa251bd5c7741c7b99de688c2da220a.png' />
                  <div class="all-rank-name">{{ earlyProgressTop3[2].studentName }}</div>
                  <div class="all-rank-class">{{ earlyProgressTop3[2].gradeName }}</div>
                  <div class="all-rank-score">{{ earlyProgressTop3[2].progress }}<span v-if="currentProgressDataset == 'word'">%</span></div>
                </div>
                <div class="all-rank-item third skeleton-item" v-else>
                  <div class="skeleton-avatar skeleton"></div>
                  <div class="skeleton-medal skeleton"></div>
                  <div class="skeleton-name skeleton"></div>
                  <div class="skeleton-class skeleton"></div>
                  <div class="skeleton-score skeleton"></div>
                </div>
              </div>
              <div class="table-content" style="margin-top: 15px;">
                <dl class="table-header"
                :style="{ height: isScreen ? '3.2vh' : '33px' }"
                >
                  <dt class="rank-column">排名</dt>
                  <dt class="name-column1">姓名</dt>
                  <dt class="class-column2">班级名称</dt>
                  <dt class="progress-column">较上次进步值</dt>
                  <dt class="description-column">备注</dt>
                </dl>
                <div class="carousel-container">
                  <el-carousel
                    :ref="(el) => (carouselStates.earlyProgress.ref.value = el)"
                    :style="{ height: earlyArrivalCarouselHeight + 'vh' }"
                    v-if="earlyProgressList.length > 0"
                    arrow="never"
                    indicator-position="none"
                    direction="vertical"
                    :autoplay="true"
                    :interval="5000"
                    @change="
                      (index) => handleCarouselChange('earlyProgress', index)
                    "
                  >
                    <el-carousel-item
                      v-for="(itm, i) in earlyProgressList"
                      :key="i"
                    >
                      <dl
                        v-for="(item, index) in itm"
                        :key="index"
                        :class="[
                          'table-row',
                          index % 2 !== 0 ? 'columns-style' : '',
                        ]"
                  :style="{ height: isScreen ? '3.2vh' : '33px' }"
                      >
                        <dt class="rank-column">{{ item.orderRank }}</dt>
                        <dt class="name-column1">{{ item.studentName }}</dt>
                        <dt class="class-column2">{{ item.className }}</dt>
                        <dt class="progress-column">
                          {{ item.attendanceRate }}<span v-if="currentProgressDataset == 'word'">%</span>
                        </dt>
                        <dt class="description-column">
                          {{ item.description }}
                        </dt>
                      </dl>
                    </el-carousel-item>
                  </el-carousel>
                  <div v-else>
                    <dl
                      v-for="(itm,i) in 4"
                      :key="i"
                      :class="[
                        'table-row',
                        i % 2 !== 0 ? 'columns-style' : '',
                      ]"
                    :style="{ height: isScreen ? '3.2vh' : '33px' }"
                    >
                      <dt class="rank-column">
                        <div class="skeleton skeleton-text"></div>
                      </dt>
                      <dt class="name-column1">
                        <div class="skeleton skeleton-text"></div>
                      </dt>
                      <dt class="class-column2">
                        <div class="skeleton skeleton-text"></div>
                      </dt>
                      <dt class="progress-column">
                        <div class="skeleton skeleton-text"></div>
                      </dt>
                      <dt class="description-column">
                        <div class="skeleton skeleton-text"></div>
                      </dt>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-right">
        <div class="card work-card">
          <div class="card-title-line"></div>
          <div class="card-title">
            <span>课堂活跃达人榜</span>
            <div class="card-title-right" style="display:flex;align-items:center;gap:8px;">
              <div 
                class="content-right-top-item hand active"
              >
                近{{ recentlyDayCourse }}日
              </div>
              <!--<div 
                class="content-right-top-item hand"
                :class="{ active: classroomActivityTimeRange === '30d' }"
                @click="classroomActivityTimeRange = '30d'"
              >
                近30日
              </div>-->
            </div>
          </div>
          <img
            class="segmentation"
            src="https://appfile2.sbgw.cn/hhsbzhxt/d2e4f540152b4fdeaefecbd99c1ec6cc.png"
            alt="card分割线"
          />
          <div class="homework-submit-data">
            <div class="table-title-container">
              <div></div>
              <div class="carousel-indicators">
                <div
                  v-for="(_, index) in homeworkSubmitData"
                  :key="index"
                  class="indicator"
                  :class="{
                    active:
                      carouselStates.homework.currentIndex.value === index,
                  }"
                  @click="() => setCarouselActivePage('homework', index)"
                ></div>
              </div>
            </div>
            <div class="table-content">
              <dl class="table-header1"
                :style="{ height: isScreen ? '3.2vh' : '33px' }"
              >
                <dt class="rank-column">排名</dt>
                <dt class="name-column">姓名</dt>
                <dt class="class-column">班级名称</dt>
                <dt class="excess-column">对应积分值</dt>
                <dt class="number-of-excess-column">总积分</dt>
              </dl>
              <div class="carousel-container">
                <el-carousel
                  :ref="(el) => (carouselStates.homework.ref.value = el)"
                  style="height: 15vh"
                  v-if="homeworkSubmitData.length > 0"
                  arrow="never"
                  indicator-position="none"
                  direction="vertical"
                  :autoplay="true"
                  :interval="5000"
                  @change="(index) => handleCarouselChange('homework', index)"
                >
                  <el-carousel-item
                    v-for="(itm, i) in homeworkSubmitData"
                    :key="i"
                  >
                    <dl
                      v-for="(item, index) in itm"
                      :key="index"
                      :class="[
                        'table-row1',
                        index % 2 !== 0 ? 'columns-style' : '',
                      ]"
                    :style="{ height: isScreen ? '3.2vh' : '33px' }"
                    >
                      <dt class="rank-column">
                       <img class="rank-img" v-if="item.rank == 1 || item.rank == 2 || item.rank == 3" :src="item.rank == 1 ?
                        'https://appfile2.sbgw.cn/hhsbzhxt/7b60769690a245e2b390af172fb43e76.png' : item.rank == 2 ?
                        'https://appfile2.sbgw.cn/hhsbzhxt/7a2e4581bbec41778dc196b47998f142.png' :
                        'https://appfile2.sbgw.cn/hhsbzhxt/9fa251bd5c7741c7b99de688c2da220a.png'"/>
                       <span v-else>{{ item.rank }}</span>
                      </dt>
                      <dt class="name-column">{{ item.studentName || '--' }}</dt>
                      <dt class="class-column">{{ item.gradeName || '--' }}</dt>
                      <dt class="excess-column">出勤早到{{ item.earlyToScore }}&nbsp;&nbsp;回答问题{{ item.answerScore }}</dt>
                      <dt class="number-of-excess-column">{{ item.totalScore }}</dt>
                    </dl>
                  </el-carousel-item>
                </el-carousel>
                <div v-else>
                  <dl
                    v-for="(item, index) in 4"
                    :key="index"
                    :class="[
                      'table-row',
                      index % 2 !== 0 ? 'columns-style' : '',
                    ]"
                    :style="{ height: isScreen ? '3.2vh' : '33px' }"
                  >
                    <dt class="rank-column"></dt>
                    <dt class="name-column"></dt>
                    <dt class="class-column"></dt>
                    <dt class="excess-column"></dt>
                    <dt class="number-of-excess-column"></dt>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card work-card">
          <div class="card-title-line"></div>
          <div class="card-title">
            <span>考点检测达人榜</span>
            <div class="card-title-right" style="display:flex;align-items:center;gap:8px;">
              <div 
                class="content-right-top-item hand active"
              >
                近{{ recentlyWorkNumber }}次
              </div>
            </div>
          </div>
          <img
            class="segmentation"
            src="https://appfile2.sbgw.cn/hhsbzhxt/d2e4f540152b4fdeaefecbd99c1ec6cc.png"
            alt="card分割线"
          />
          <div class="homework-submit-data">
            <div class="table-title-container">
              <div></div>
              <div class="carousel-indicators">
                <div
                  v-for="(_, index) in workExpertList"
                  :key="index"
                  class="indicator"
                  :class="{
                    active:
                      carouselStates.workExpert.currentIndex.value === index,
                  }"
                  @click="() => setCarouselActivePage('workExpert', index)"
                ></div>
              </div>
            </div>
            <div class="table-content">
              <dl class="table-header1"
                :style="{ height: isScreen ? '3.2vh' : '33px' }"
              >
                <dt class="rank-column">排名</dt>
                <dt class="name-column">姓名</dt>
                <dt class="class-column">班级名称</dt>
                <dt class="number-of-excess-column mr-15">按时提交率</dt>
                <dt class="number-of-excess-column">平均得分率</dt>
              </dl>
              <div class="carousel-container">
                <el-carousel
                  :ref="(el) => (carouselStates.workExpert.ref.value = el)"
                  style="height: 15vh"
                  v-if="workExpertList.length > 0"
                  arrow="never"
                  indicator-position="none"
                  direction="vertical"
                  :autoplay="true"
                  :interval="5000"
                  @change="(index) => handleCarouselChange('workExpert', index)"
                >
                  <el-carousel-item
                    v-for="(itm, i) in workExpertList"
                    :key="i"
                  >
                    <dl
                      v-for="(item, index) in itm"
                      :key="index"
                      :class="[
                        'table-row1',
                        index % 2 !== 0 ? 'columns-style' : '',
                      ]"
                    :style="{ height: isScreen ? '3.2vh' : '33px' }"
                    >
                     <dt class="rank-column">
                       <img class="rank-img" v-if="item.rank == 1 || item.rank == 2 || item.rank == 3" :src="item.rank == 1 ?
                        'https://appfile2.sbgw.cn/hhsbzhxt/7b60769690a245e2b390af172fb43e76.png' : item.rank == 2 ?
                        'https://appfile2.sbgw.cn/hhsbzhxt/7a2e4581bbec41778dc196b47998f142.png' :
                        'https://appfile2.sbgw.cn/hhsbzhxt/9fa251bd5c7741c7b99de688c2da220a.png'"/>
                       <span v-else>{{ item.rank }}</span>
                      </dt>
                      <dt class="name-column">{{ item.studentName || '--' }}</dt>
                      <dt class="class-column">{{ item.gradeName || '--' }}</dt>
                      <dt class="number-of-excess-column mr-15">{{ item.workSumbitPercent }}%</dt>
                      <dt class="number-of-excess-column">{{ item.scoreAvgPercent }}%</dt>
                    </dl>
                  </el-carousel-item>
                </el-carousel>
                <div v-else>
                  <dl
                    v-for="(item, index) in workExpertItemsPerPage"
                    :key="index"
                    :class="[
                      'table-row',
                      index % 2 !== 0 ? 'columns-style' : '',
                    ]"
                    :style="{ height: isScreen ? '3.2vh' : '33px' }"
                  >
                    <dt class="rank-column">
                      <div class="skeleton skeleton-text"></div>
                    </dt>
                    <dt class="name-column">
                      <div class="skeleton skeleton-text"></div>
                    </dt>
                    <dt class="class-column">
                      <div class="skeleton skeleton-text"></div>
                    </dt>
                    <dt class="number-of-excess-column">
                      <div class="skeleton skeleton-text"></div>
                    </dt>
                    <dt class="number-of-excess-column">
                      <div class="skeleton skeleton-text"></div>
                    </dt>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
         <div class="card work-card">
          <div class="card-title-line"></div>
          <div class="card-title">
            <span>词汇量挑战榜</span>
            <div class="card-title-right" style="display:flex;align-items:center;gap:8px;">
              <div 
                class="content-right-top-item hand active"
              >
                正确率仅计算最近{{ vocabularyChallengeDefaultDays }}次平均值
              </div>
            </div>
          </div>
          <img
            class="segmentation"
            src="https://appfile2.sbgw.cn/hhsbzhxt/d2e4f540152b4fdeaefecbd99c1ec6cc.png"
            alt="card分割线"
          />
          <div class="homework-submit-data">
            <div class="table-title-container">
              <div></div>
              <div class="carousel-indicators">
                <div
                   v-for="(_, index) in vocabularyChallengeList"
                  :key="index"
                  class="indicator"
                  :class="{
                     active: carouselStates.vocabulary.currentIndex.value === index,
                  }"
                   @click="() => setCarouselActivePage('vocabulary', index)"
                ></div>
              </div>
            </div>
            <div class="table-content">
              <dl class="table-header1"
                :style="{ height: isScreen ? '3.2vh' : '33px' }"
              >
                <dt class="rank-column">排名</dt>
                <dt class="name-column">姓名</dt>
                <dt class="class-column">班级名称</dt>
                <dt class="number-of-excess-column mr-15">已练单词</dt>
                <dt class="number-of-excess-column">练习正确率</dt>
              </dl>
              <div class="carousel-container">
                <el-carousel
                   :ref="(el) => (carouselStates.vocabulary.ref.value = el)"
                  style="height: 15vh"
                   v-if="vocabularyChallengeList.length > 0"
                  arrow="never"
                  indicator-position="none"
                  direction="vertical"
                  :autoplay="true"
                  :interval="5000"
                   @change="(index) => handleCarouselChange('vocabulary', index)"
                >
                  <el-carousel-item
                     v-for="(itm, i) in vocabularyChallengeList"
                    :key="i"
                  >
                    <dl
                      v-for="(item, index) in itm"
                      :key="index"
                      :class="[
                        'table-row1',
                        index % 2 !== 0 ? 'columns-style' : '',
                      ]"
                    :style="{ height: isScreen ? '3.2vh' : '33px' }"
                    >
                       <dt class="rank-column">
                        <img class="rank-img" v-if="item.rank == 1 || item.rank == 2 || item.rank == 3" :src="item.rank == 1 ?
                         'https://appfile2.sbgw.cn/hhsbzhxt/7b60769690a245e2b390af172fb43e76.png' : item.rank == 2 ?
                         'https://appfile2.sbgw.cn/hhsbzhxt/7a2e4581bbec41778dc196b47998f142.png' :
                         'https://appfile2.sbgw.cn/hhsbzhxt/9fa251bd5c7741c7b99de688c2da220a.png'"/>
                        <span v-else>{{ item.rank }}</span>
                       </dt>
                       <dt class="name-column">{{ item.studentName || '--' }}</dt>
                       <dt class="class-column1 mr-15">{{ item.gradeName || '--' }}</dt>
                       <dt class="number-of-excess-column mr-15">{{ item.practiceWordCount }}</dt>
                       <dt class="number-of-excess-column">{{ (item.accuracy*100).toFixed(1) }}%</dt>
                    </dl>
                  </el-carousel-item>
                </el-carousel>
                <div v-else>
                  <dl
                    v-for="(item, index) in 4"
                    :key="index"
                    :class="[
                      'table-row',
                      index % 2 !== 0 ? 'columns-style' : '',
                    ]"
                    :style="{ height: isScreen ? '3.2vh' : '33px' }"
                  >
                    <dt class="rank-column"></dt>
                    <dt class="name-column"></dt>
                    <dt class="class-column"></dt>
                    <dt class="number-of-excess-column"></dt>
                    <dt class="number-of-excess-column"></dt>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted ,reactive, watch, watchEffect, nextTick, getCurrentInstance, computed } from "vue";
import * as echarts from "echarts";
import { transform } from "lodash";
import $ from "jquery";
import { 
  GetWeatherMessage,  
  GetNowYearGradeIds
} from '../network/learnBigData';
import { GetVocabularyChallengeRanking, GetStudyPersistIn, GetTopStudetnReportEarlyList, GetWorkExpertList, GetTopStudetnReportWordList, GetTopStudetnReportWorkList, GetOfflineExaminationAverageScoresV2, GetTopStudetnReportExamList, GetClassroomActivity, GetTopStudetnReportCourseList, GetTopStudentInfo, GetTopStudentDataList } from '../network/personalHonorReport';
import { timeFormatNew } from "@/common/utils";

// 获取当前实例来访问路由
const { proxy } = getCurrentInstance();

// 生成今天在内的前七天日期
const generateLastSixDays = () => {
  const dates = [];
  for (let i = 6; i >= 0; i--) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    dates.push(timeFormatNew(date, 'MM.dd'));
  }
  return dates;
};

// 学习坚持榜时间范围（昨日/近7日/近30日）
const timeRange = ref('yesterday');
// 课堂活跃达人榜时间范围（近7日/近30日）
const classroomActivityTimeRange = ref('7d');
// 当前时间
const currentTime = ref("");
const currentDate = ref("");

// 今日寄语
const todayMessage = ref([]);
const recentlyWorkNumber = ref(2);
const recentlyDayCourse = ref(7);
const vocabularyChallengeDefaultDays = ref(33);
const temperature = ref(0);
// 当前学年ID（从天气接口获取）
const nowYearGrade = ref(0); 

const getTodayWeather = async (obj) => {
  const res = await GetWeatherMessage(obj);
  if(res.code === 1){
    weatherType.value = res.result.weatherType;
    temperature.value = res.result.temperature;
    // 从接口获取当前学年ID
    if (res.result.nowYearGrade) {
      nowYearGrade.value = res.result.nowYearGrade;
    }
    // 使用获取到的学年ID或默认值12来获取考试信息
    getYearData(nowYearGrade.value);
  } else {
    nowYearGrade.value = 0;
    getYearData(nowYearGrade.value);
  }
}
const loading = ref(false);
// 天气模块数据声明
const weatherType = ref("晴天");

// 时间模块
const time = ref(new Date());

// 今日寄语滚动定时器
const messageTimer = ref(null);

// 5分钟自动刷新定时器
const autoRefreshTimer = ref(null);

// 走马灯
const carouselStates = {
  attendance: {
    ref: ref(null), // 走马灯组件ref
    currentIndex: ref(0), // 当前页码
  },
  earlyArrival: {
    ref: ref(null),
    currentIndex: ref(0),
  },
  exam: {
    ref: ref(null),
    currentIndex: ref(0),
  },
  integral: {
    ref1: ref(null),
    ref2: ref(null),
    currentIndex: ref(0),
  },
  homework: {
    ref: ref(null),
    currentIndex: ref(0),
  },
  vocabulary: {
    ref: ref(null),
    currentIndex: ref(0),
  },
  wordLearning: {
    ref: ref(null),
    currentIndex: ref(0),
  },
  pkRank: {
    ref: ref(null),
    currentIndex: ref(0),
  },
  earlyProgress: {
    ref: ref(null),
    currentIndex: ref(0),
  },
  workExpert: {
    ref: ref(null),
    currentIndex: ref(0),
  },
};

// ---------------学习坚持数据声明---------------
const schoolAttendanceRate = ref(0);
const attendanceRateList = ref([]);
// 综合学霸榜数据列表
const allStudentList = ref([]);
// 综合学霸榜原始数据（用于重新分组）
const allStudentRawData = ref([]);
// 综合学霸榜前三名
const allStudentTop3 = ref([]);
// 综合学霸榜卡片高度
const allStudentCarouselHeight = ref(null);
// 班级早到人数数据列表
const topStudentList = ref([]);
const earlyArrivalList = ref([]);
// 学习坚持榜原始数据（用于重新分组）
const studyPersistenceRawData = ref([]);
// 每列显示的条数（根据窗口高度动态调整：880高度7条，920高度8条）
const itemsPerColumn = ref(7);
// 学习坚持榜卡片高度（880->365px，920->398px，其它保留当前格局不强制高度）
const studyCardHeight = ref(null);
const elCarouselHeight = ref(null);
// 早到榜卡片高度
const earlyArrivalCarouselHeight = ref(null);
// 线下考试卡片高度
const examCardHeight = ref(null);
const chartHeight = ref(35);
// 线下考试每页显示条数（920显示10条，880显示7条）
const examItemsPerPage = ref(7);
// 视口高度与 px->vh 转换
const viewportHeight = ref(window.innerHeight);
const pxToVh = (px) => {
  if (!px || !viewportHeight.value) return 0;
  return (px / viewportHeight.value) * 100;
};
// 综合学霸榜每页显示条数（920显示10条，880显示7条）
const comprehensiveRankItemsPerPage = ref(4);
// 是否是大屏
const isScreen = ref(false);
// 进步之星（早到/单词）
const progressStarItemsPerPage = ref(7); // 920/880 显示5条，大屏7条
const currentProgressDataset = ref('early'); // 'early' | 'word' | 'work' | 'exam' | 'course'
const progressStarTitle = ref('早到进步之星');
// 进步之星自动切换定时器
let progressAutoSwitchTimer = null;
// 记录是否已经完整展示一轮（用于判断是否应该切换数据集）
const progressDatasetCompleteRound = ref(false);
// 展示用容器（绑定到模板）
const earlyProgressList = ref([]);
const earlyProgressTop3 = ref([]);
// 数据源容器
const earlyProgressListSrc = ref([]);
const earlyProgressTop3Src = ref([]);
const wordProgressListSrc = ref([]);
const wordProgressTop3Src = ref([]);
const workProgressListSrc = ref([]);
const workProgressTop3Src = ref([]);
const examProgressListSrc = ref([]);
const examProgressTop3Src = ref([]);
const courseProgressListSrc = ref([]);
const courseProgressTop3Src = ref([]);
// 进步之星指示器顺序
const progressDatasetOrder = ['early', 'word', 'work', 'exam', 'course'];

// 检查某个数据集是否有数据
const hasProgressData = (datasetType) => {
  let hasTop3 = false;
  let hasList = false;
  
  switch (datasetType) {
    case 'early':
      hasTop3 = earlyProgressTop3Src.value && earlyProgressTop3Src.value.length > 0;
      hasList = earlyProgressListSrc.value && earlyProgressListSrc.value.length > 0;
      break;
    case 'word':
      hasTop3 = wordProgressTop3Src.value && wordProgressTop3Src.value.length > 0;
      hasList = wordProgressListSrc.value && wordProgressListSrc.value.length > 0;
      break;
    case 'work':
      hasTop3 = workProgressTop3Src.value && workProgressTop3Src.value.length > 0;
      hasList = workProgressListSrc.value && workProgressListSrc.value.length > 0;
      break;
    case 'exam':
      hasTop3 = examProgressTop3Src.value && examProgressTop3Src.value.length > 0;
      hasList = examProgressListSrc.value && examProgressListSrc.value.length > 0;
      break;
    case 'course':
      hasTop3 = courseProgressTop3Src.value && courseProgressTop3Src.value.length > 0;
      hasList = courseProgressListSrc.value && courseProgressListSrc.value.length > 0;
      break;
  }
  
  return hasTop3 || hasList;
};

// 获取有数据的数据集列表（计算属性）
const availableProgressDatasets = computed(() => {
  return progressDatasetOrder.filter(dataset => hasProgressData(dataset));
});

// ----------------线下考试模块数据声明---------------
const currentYearExams = ref([]); // 当年所有考试
const examClassRankList = ref([]); // 班级排名列表，与 currentYearExams 对应
const currentExamIndex = ref(0);   // 当前考试下标
const currentExamCarouselIndex = ref(0); // 当前考试下的走马灯页码
const examCarouselRef = ref(null); // 走马灯ref
let examAutoSwitchTimer = null;

const offlineExamInationChartRef = ref(null);
let offlineExamInationChart = null;

const offlineExamInationChartData = ref({
  dates: [],
  values: [],
});

// 自动切换考试和页的定时器逻辑
const startExamAutoSwitch = () => {
  clearTimeout(examAutoSwitchTimer);
  if (!examClassRankList.value.length || !currentYearExams.value.length) return;
  const currentExamData = examClassRankList.value[currentExamIndex.value];
  if (!currentExamData || !currentExamData.length) {
     examAutoSwitchTimer = setTimeout(switchToNextExam, 5000);
     return;
  };

  const currentPage = currentExamCarouselIndex.value;
  const currentPages = currentExamData.length;

  if (currentPages <= 1) {
    // 只有一页或没有数据，5秒后切换考试
    examAutoSwitchTimer = setTimeout(switchToNextExam, 5000);
  } else {
    // 多页，最后一页5秒后切换考试，否则5秒后切换下一页
    examAutoSwitchTimer = setTimeout(() => {
      if (currentPage >= currentPages - 1) {
        switchToNextExam();
      } else {
        // 切换到下一页
        examCarouselRef.value?.setActiveItem(currentPage + 1);
      }
    }, 5000);
  }
};

// 自动切换逻辑
const handleExamCarouselChange = (index) => {
  currentExamCarouselIndex.value = index;
  startExamAutoSwitch();
};

const switchToNextExam = () => {
  let nextIndex = currentExamIndex.value + 1;
  if (nextIndex >= currentYearExams.value.length) {
    nextIndex = 0;
  }
  currentExamIndex.value = nextIndex;
  currentExamCarouselIndex.value = 0;
  // 走马灯回到第一页
  examCarouselRef.value?.setActiveItem(0);
  startExamAutoSwitch(); // 重启定时器
};

const handleExamDotClick = (index) => {
  currentExamIndex.value = index;
  currentExamCarouselIndex.value = 0;
  examCarouselRef.value?.setActiveItem(0);
  startExamAutoSwitch();
};

// 监听考试切换和数据变化时重启定时器
watch([currentExamIndex, examClassRankList], () => {
  startExamAutoSwitch();
});


// ----------------作业模块数据声明---------------
// 作业数据提交列表（用于课堂活跃达人榜）
const homeworkSubmitData = ref([]);
// 课堂活跃达人榜原始数据
const homeworkSubmitRawData = ref([]);
// 课堂活跃达人榜每页显示的条数
const homeworkSubmitItemsPerPage = ref(4);
// 作业达人榜数据列表
const workExpertList = ref([]);
const workExpertRawData = ref([]);
const workExpertItemsPerPage = ref(4);

// ----------------词汇量挑战榜数据声明---------------
const vocabularyChallengeList = ref([]);
const vocabularyChallengeRawData = ref([]);
const vocabularyItemsPerPage = ref(4);

// ----------------单词学习模块数据声明---------------
// 班级单词学习数据
const wordLearningRankData = ref([]);

// 全校线下考试平均分趋势图
const initOfflineExamInationChart = () => {
  if (offlineExamInationChartRef.value) {
    offlineExamInationChart = echarts.init(offlineExamInationChartRef.value);
    const allZero = offlineExamInationChartData.value.values.every(item => item.value === 0)
    if (allZero) {
      const option = {
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            // 处理长名称换行
            const formatName = (name) => {
              if (name.length > 8) {
                // 每12个字符换一行
                return name.replace(/(.{8})/g, '$1<br>');
              }
              return name;
            };
            
            return `<div style="width:164px;">
                <div style="font-size: 12px; color: #303113; font-weight: 600;">全校线下考试得分率</div>
                <div style="background-color:#fff; font-size: 12px; color: #606266;font-weight: 400;display: flex;justify-content: space-between;padding: 6px 8px;">
                  <span style="word-break: break-all;">${formatName(params[0].name)}</span>
                  <span style="color: #303113; font-weight: 600; font-size: 13px; margin-left: 8px;">${params[0].value}</span>
                </div>
              </div>`;
          },
          backgroundColor: "#F3F3F3",
          borderWidth: 1,
          position: function (pos, params, el, elRect, size) {
            const obj = { top: 10 };
            obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 30;
            return obj;
          },
          extraCssText: "z-index: 100;",
          axisPointer: {
            type: "line",
            lineStyle: {
              color: "#FFA632",
              type: "dashed",
            },
            label: {
              backgroundColor: "#FFA632",
            },
          },
        },
        grid: {
          top: "10px",
          left: "20px",
          right: "5px",
          bottom: "5px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: [`英语摸底考试` ,`《基础语法》考试`,`《语篇精讲》考试`,`《核心语法》考试`,`英语模考二`],
          axisLine: {
            lineStyle: {
              color: "#E5E5E5",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#666",
            interval: 0,
            rotate: 45, 
            fontSize: 10,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#E5E5E5",
              type: "dashed",
            },
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: ["rgba(250,250,250,0.3)", "rgba(245,245,245,0.3)"],
            },
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 100,
          interval: 20,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: "#E5E5E5",
              type: "dashed",
            },
          },
          axisLabel: {
            color: "#666",
          },
        },
        series: [
          {
            data: [],
            type: "line",
            smooth: false,
            showSymbol: true,
            symbolSize: 8,
            itemStyle: {
              color: "#FFA632",
              borderColor: "#FFA632",
              borderWidth: 2,
            },
            lineStyle: {
              color: "#FFA632",
              width: 2,
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(255,166,50,0.5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(255,166,50,0.1)",
                  },
                ],
              },
            },
          },
        ],
      };
      offlineExamInationChart.setOption(option);
      return;
    }
    const option = {
      tooltip: {
        trigger: "axis",
        formatter: function (params) {
          // 处理长名称换行
          const formatName = (name) => {
            if (name.length > 8) {
              // 每12个字符换一行
              return name.replace(/(.{8})/g, '$1<br>');
            }
            return name;
          };
          
          return `<div style="width:164px;">
              <div style="font-size: 12px; color: #303113; font-weight: 600;">全校线下考试得分率</div>
              <div style="background-color:#fff; font-size: 12px; color: #606266;font-weight: 400;display: flex;justify-content: space-between;padding: 6px 8px;">
                <span style="word-break: break-all;">${formatName(params[0].name)}</span>
                <span style="color: #303113; font-weight: 600; font-size: 13px; margin-left: 8px;">${params[0].value}</span>
              </div>
            </div>`;
        },
        backgroundColor: "#F3F3F3",
        borderWidth: 1,
        position: function (pos, params, el, elRect, size) {
          const obj = { top: 10 };
          obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 30;
          return obj;
        },
        extraCssText: "z-index: 100;",
        axisPointer: {
          type: "line",
          lineStyle: {
            color: "#FFA632",
            type: "dashed",
          },
          label: {
            backgroundColor: "#FFA632",
          },
        },
      },
      grid: {
        top: "10px",
        left: "20px",
        right: "5px",
        bottom: "5px",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: true,
        data: [
          ...offlineExamInationChartData.value.dates,
        ],
        axisLine: {
          lineStyle: {
            color: "#E5E5E5",
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: "#666",
          interval: 0,
          rotate: 45, 
          fontSize: 10,
          formatter: function (value) {
            return value.length > 10 ? value.slice(0,10) : value;
          }
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#E5E5E5",
            type: "dashed",
          },
        },
        splitArea: {
          show: true,
          areaStyle: {
            color: ["rgba(250,250,250,0.3)", "rgba(245,245,245,0.3)"],
          },
        },
      },
      yAxis: {
        type: "value",
        min: 0,
        max: 100,
        interval: 20,
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          lineStyle: {
            color: "#E5E5E5",
            type: "dashed",
          },
        },
        axisLabel: {
          color: "#666",
        },
      },
      series: [
        {
          data: offlineExamInationChartData.value.values,
          type: "line",
          smooth: false,
          showSymbol: true,
          symbolSize: 8,
          itemStyle: {
            color: "#FFA632",
            borderColor: "#FFA632",
            borderWidth: 2,
          },
          lineStyle: {
            color: "#FFA632",
            width: 2,
          },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(255,166,50,0.5)",
                },
                {
                  offset: 1,
                  color: "rgba(255,166,50,0.1)",
                },
              ],
            },
          },
        },
      ],
    };
    offlineExamInationChart.setOption(option);
  }
};

// 天气
const getImageSrc = (weatherType) => {
  if (weatherType?.includes("云"))
    return "https://appfile2.sbgw.cn/hhxtj/2fff8c51447d470495e123ee64c421e5.png";
  if (weatherType?.includes("雨"))
    return "https://appfile2.sbgw.cn/hhxtj/dafe68ee897240d0a24d2ffcb41f485f.png";
  if (weatherType?.includes("雪"))
    return "https://appfile2.sbgw.cn/hhxtj/fcced926fa5543339ca2e30324ec48cc.png";
  if (weatherType?.includes("晴") || weatherType?.includes("阳"))
    return "https://appfile2.sbgw.cn/hhxtj/0d770c0355dc4fb8bc36fa3f6d40e4ec.png";
  // 可以在这里添加默认情况
  return "https://appfile2.sbgw.cn/hhxtj/2fff8c51447d470495e123ee64c421e5.png"; // 返回默认图片路径
};

// 处理时间
const updateTime = () => {
  // 获取当前时间
  const now = new Date();
  // 格式化时间为字符串
  const formattedTime = now.toLocaleTimeString();
  currentTime.value = formattedTime;
  // 每秒更新一次时间
  setTimeout(() => updateTime(), 1000);
  // 获取当前日期
  const nowDay = new Date();

  // 格式化日期
  const year = nowDay.getFullYear();
  const month = String(nowDay.getMonth() + 1).padStart(2, "0");
  const day = String(nowDay.getDate()).padStart(2, "0");
  currentDate.value = `${year}.${month}.${day}`;
};


// 监听窗口大小变化
let resizeTimer = null;
const handleResize = () => {
  if (resizeTimer) clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    offlineExamInationChart && offlineExamInationChart.resize();
    // 更新视口高度，驱动 px->vh 重新计算
    viewportHeight.value = window.innerHeight;
    
    // 重新计算每列显示的条数并重新分组学习坚持榜数据
    const oldItemsPerColumn = itemsPerColumn.value;
    const oldProgressPerPage = progressStarItemsPerPage.value;
    calculateItemsPerColumn();
    
    // 如果每列条数发生变化，重新分组数据
    if (oldItemsPerColumn !== itemsPerColumn.value) {
      regroupStudyPersistenceData();
      // 重置轮播到第一页
      carouselStates.attendance.currentIndex.value = 0;
      carouselStates.earlyArrival.currentIndex.value = 0;
      if (carouselStates.attendance.ref.value) {
        carouselStates.attendance.ref.value.setActiveItem(0);
      }
      if (carouselStates.earlyArrival.ref.value) {
        carouselStates.earlyArrival.ref.value.setActiveItem(0);
      }
    }

    // 进步之星每页数量变化时，重新分组两类源数据并应用
    if (oldProgressPerPage !== progressStarItemsPerPage.value) {
      const regroup = (list) => {
        const out = [];
        for (let i = 0; i < list.length; i += progressStarItemsPerPage.value) {
          out.push(list.slice(i, i + progressStarItemsPerPage.value));
        }
        return out;
      };
      // 重新分组源数据（保持 top3 不受影响）
      const flatEarly = earlyProgressListSrc.value.flat();
      earlyProgressListSrc.value = regroup(flatEarly);
      const flatWord = wordProgressListSrc.value.flat();
      wordProgressListSrc.value = regroup(flatWord);
      const flatWork = workProgressListSrc.value.flat();
      workProgressListSrc.value = regroup(flatWork);
      const flatExam = examProgressListSrc.value.flat();
      examProgressListSrc.value = regroup(flatExam);
      const flatCourse = courseProgressListSrc.value.flat();
      courseProgressListSrc.value = regroup(flatCourse);
      // 应用到当前展示
      if (currentProgressDataset.value === 'early') {
        earlyProgressList.value = earlyProgressListSrc.value;
        earlyProgressTop3.value = earlyProgressTop3Src.value;
        progressStarTitle.value = '早到进步之星';
      } else if (currentProgressDataset.value === 'word') {
        earlyProgressList.value = wordProgressListSrc.value;
        earlyProgressTop3.value = wordProgressTop3Src.value;
        progressStarTitle.value = '单词进步之星';
      } else if (currentProgressDataset.value === 'work') {
        earlyProgressList.value = workProgressListSrc.value;
        earlyProgressTop3.value = workProgressTop3Src.value;
        progressStarTitle.value = '作业进步之星';
      } else if (currentProgressDataset.value === 'exam') {
        earlyProgressList.value = examProgressListSrc.value;
        earlyProgressTop3.value = examProgressTop3Src.value;
        progressStarTitle.value = '考试进步之星';
      } else if (currentProgressDataset.value === 'course') {
        earlyProgressList.value = courseProgressListSrc.value;
        earlyProgressTop3.value = courseProgressTop3Src.value;
        progressStarTitle.value = '课堂进步之星';
      }
      carouselStates.earlyProgress.currentIndex.value = 0;
      carouselStates.earlyProgress.ref.value?.setActiveItem(0);
    }

    // 作业达人榜每页数量变化时，根据原始数据重新分组并重置页码
    // 仅当已有原始数据时执行
    if (workExpertRawData.value && workExpertRawData.value.length > 0) {
      const regroupWork = (arr, size) => {
        const out = [];
        for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
        return out;
      };
      workExpertList.value = regroupWork(workExpertRawData.value, workExpertItemsPerPage.value);
      carouselStates.workExpert.currentIndex.value = 0;
      carouselStates.workExpert.ref.value?.setActiveItem(0);
    }

    // 课堂活跃达人榜每页数量变化时，根据原始数据重新分组并重置页码
    // 仅当已有原始数据时执行
    if (homeworkSubmitRawData.value && homeworkSubmitRawData.value.length > 0) {
      const regroupHomework = (arr, size) => {
        const out = [];
        for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
        return out;
      };
      homeworkSubmitData.value = regroupHomework(homeworkSubmitRawData.value, homeworkSubmitItemsPerPage.value);
      carouselStates.homework.currentIndex.value = 0;
      carouselStates.homework.ref.value?.setActiveItem(0);
    }

    // 词汇量挑战榜每页数量变化时，根据原始数据重新分组并重置页码
    // 仅当已有原始数据时执行
    if (vocabularyChallengeRawData.value && vocabularyChallengeRawData.value.length > 0) {
      vocabularyChallengeList.value = groupData(vocabularyChallengeRawData.value, vocabularyItemsPerPage.value);
      carouselStates.vocabulary.currentIndex.value = 0;
      carouselStates.vocabulary.ref.value?.setActiveItem(0);
    }

    // 综合学霸榜每页数量变化时，根据原始数据重新分组并重置页码
    // 仅当已有原始数据时执行（列表数据从第4名开始）
    if (allStudentRawData.value && allStudentRawData.value.length > 0) {
      const listData = allStudentRawData.value.slice(3); // 从第4名开始
      allStudentList.value = groupData(listData, comprehensiveRankItemsPerPage.value);
      carouselStates.attendance.currentIndex.value = 0;
      carouselStates.attendance.ref.value?.setActiveItem(0);
    }
  }, 100); // 降低延迟，使响应更快
};

// 走马灯相关设置
const setCarouselActivePage = (type, index) => {
  if (type === "integral") {
    integralIndex.value = index;
    carouselStates[type].currentIndex.value = index;
    
    // 确保两个走马灯状态同步
    if (carouselStates[type].ref1.value) {
      carouselStates[type].ref1.value.setActiveItem(index);
    }
    if (carouselStates[type].ref2.value) {
      carouselStates[type].ref2.value.setActiveItem(index);
    }
    
    updatePieChartData(index);
    classIntegralInitPieChart1(); // 重新初始化饼图1
    classIntegralInitPieChart2(); // 重新初始化饼图2
  } else {
    carouselStates[type].currentIndex.value = index;
    carouselStates[type].ref.value?.setActiveItem(index);
  }
};


// 在轮转事件中调用更新函数
const handleCarouselChange = (type, index) => {
  if (type === "integral") {
    integralIndex.value = index;
    
    // 确保两个走马灯状态同步
    if (carouselStates[type].ref1.value) {
      carouselStates[type].ref1.value.setActiveItem(index);
    }
    if (carouselStates[type].ref2.value) {
      carouselStates[type].ref2.value.setActiveItem(index);
    }
    
    updatePieChartData(index);
    classIntegralInitPieChart1(); // 重新初始化饼图1
    classIntegralInitPieChart2(); // 重新初始化饼图2

    carouselStates[type].currentIndex.value = index;
  } else {
    // 针对进步之星：在一轮滚动完（最后一页->第一页）后自动切换数据集
    if (type === 'earlyProgress') {
      const prevIndex = carouselStates[type].currentIndex.value;
      const pages = earlyProgressList.value.length;
      // 记录新索引
      carouselStates[type].currentIndex.value = index;
      
      // 清除之前的定时器
      if (progressAutoSwitchTimer) {
        clearTimeout(progressAutoSwitchTimer);
        progressAutoSwitchTimer = null;
      }
      
      // 如果只有一页或没有数据，设置定时器自动切换
      if (pages <= 1) {
        // 延迟切换，避免频繁触发（使用轮播的自动切换间隔时间）
        progressAutoSwitchTimer = setTimeout(() => {
          toggleProgressDataset();
          progressAutoSwitchTimer = null;
        }, 5000); // 5秒后自动切换
      } else if (pages > 1) {
        // 多页数据的情况
        if (prevIndex === pages - 1 && index === 0) {
          // 从最后一页切换回第一页
          if (progressDatasetCompleteRound.value) {
            // 已经完整展示过一轮，现在切换数据集
            progressDatasetCompleteRound.value = false;
            toggleProgressDataset();
          } else {
            // 第一次从最后一页回到第一页，标记为已完成一轮，但不切换
            // 让轮播继续从第一页开始，等待完整展示完所有页面后再切换
            progressDatasetCompleteRound.value = true;
          }
        } else if (index === pages - 1) {
          // 到达最后一页，清除之前的定时器（如果存在）
          if (progressAutoSwitchTimer) {
            clearTimeout(progressAutoSwitchTimer);
          }
          // 设置定时器，等待最后一页展示完后再允许切换数据集
          progressAutoSwitchTimer = setTimeout(() => {
            // 标记为已完成一轮，下次从最后一页回到第一页时可以切换
            progressDatasetCompleteRound.value = true;
            progressAutoSwitchTimer = null;
          }, 5000); // 等待5秒，让最后一页展示完
        } else if (index === 0 && prevIndex !== pages - 1) {
          // 从中间页面回到第一页（不是从最后一页），重置标记
          progressDatasetCompleteRound.value = false;
          // 清除定时器
          if (progressAutoSwitchTimer) {
            clearTimeout(progressAutoSwitchTimer);
            progressAutoSwitchTimer = null;
          }
        }
      }
    } else {
      carouselStates[type].currentIndex.value = index;
    }
  }
};

// 学习坚持榜轮播同步切换（左右两列同步）
const isSyncingCarousel = ref(false); // 防止循环触发的标志
const handleStudyPersistenceCarouselChange = (index, source = 'auto', carouselType = 'attendance') => {
  // 如果正在同步中，避免循环触发
  if (isSyncingCarousel.value) {
    return;
  }
  
  isSyncingCarousel.value = true;
  
  // 更新两个轮播的索引
  carouselStates.attendance.currentIndex.value = index;
  carouselStates.earlyArrival.currentIndex.value = index;
  
  // 如果是手动点击指示器，需要同步两个轮播组件
  if (source === 'manual') {
    if (carouselStates.attendance.ref.value) {
      carouselStates.attendance.ref.value.setActiveItem(index);
    }
    if (carouselStates.earlyArrival.ref.value) {
      carouselStates.earlyArrival.ref.value.setActiveItem(index);
    }
  } else {
    // 自动滚动时，同步另一个轮播
    if (carouselType === 'attendance' && carouselStates.earlyArrival.ref.value) {
      // 左侧轮播变化，同步右侧轮播
      carouselStates.earlyArrival.ref.value.setActiveItem(index);
    } else if (carouselType === 'earlyArrival' && carouselStates.attendance.ref.value) {
      // 右侧轮播变化，同步左侧轮播
      carouselStates.attendance.ref.value.setActiveItem(index);
    }
  }
  
  // 使用 nextTick 确保同步完成后再重置标志
  nextTick(() => {
    isSyncingCarousel.value = false;
  });
};

// 学习坚持榜点击指示器切换
const handleStudyPersistencePageClick = (index) => {
  handleStudyPersistenceCarouselChange(index, 'manual');
};

// 获取课堂活跃达人榜
const fetchHomeworkSubmitData = async () => {
  try {
    const response = await GetClassroomActivity();
    if (response.code === 1) {
      const data = response.result || [];
      
      // 工具函数：分组
      const groupData = (data, groupSize) => {
        return data.reduce((result, item, index) => {
          const groupIndex = Math.floor(index / groupSize);
          if (!result[groupIndex]) {
            result[groupIndex] = [];
          }
          result[groupIndex].push(item);
          return result;
        }, []);
      };
      
      // 规范化字段，映射API返回的数据到模板需要的格式
      const normalized = data.map((item, index) => ({
        rank: index + 1,
        studentId: item.studentId || 0,
        studentName: item.studentName, // API中没有学生姓名，先留空，后续可能需要从其他地方获取
        gradeName: item.gradeName,
        // 保留原始数据，方便后续使用
        earlyToScore: item.earlyToScore || 0,
        answerScore: item.answerScore || 0,
        totalScore: item.totalScore || 0,
      }));
      
      // 保存原始数据
      homeworkSubmitRawData.value = normalized;
      
      // 按每页条数分组
      homeworkSubmitData.value = groupData(normalized, homeworkSubmitItemsPerPage.value);
      
      // 重置轮播到第一页
      carouselStates.homework.currentIndex.value = 0;
      if (carouselStates.homework.ref.value) {
        carouselStates.homework.ref.value.setActiveItem(0);
      }
    } else {
      homeworkSubmitData.value = [];
    }
  } catch (e) {
    console.error('获取课堂活跃达人榜数据失败:', e);
    homeworkSubmitData.value = [];
  }
};

// 获取词汇量挑战榜数据
const fetchVocabularyChallenge = async (count = 30) => {
  try {
    const res = await GetVocabularyChallengeRanking(count);
    const raw = res?.data || res?.result || [];
    // 规范化字段
    const normalized = (raw || []).map((x, idx) => ({
      rank: x.orderRank ?? x.Rank ?? x.rank ?? idx + 1,
      studentName: x.studentName ?? x.StudentName ?? '',
      gradeName: x.gradeName ?? x.GradeName ?? '',
      practiceWordCount: x.practiceWordCount ?? x.PracticeWordCount ?? 0,
      accuracy: x.accuracy ?? x.Accuracy ?? 0,
    }));
    
    // 保存原始数据
    vocabularyChallengeRawData.value = normalized;
    
    // 按每页条数分组
    vocabularyChallengeList.value = groupData(normalized, vocabularyItemsPerPage.value);
    
    // 重置轮播到第一页
    carouselStates.vocabulary.currentIndex.value = 0;
    if (carouselStates.vocabulary.ref.value) {
      carouselStates.vocabulary.ref.value.setActiveItem(0);
    }
  } catch (e) {
    console.error('获取词汇量挑战榜数据失败:', e);
    vocabularyChallengeList.value = [];
    vocabularyChallengeRawData.value = [];
  }
};

// 获取综合学霸榜总榜数据
const fetchAllStudentData = async () => {
  try {
    const response = await GetTopStudentDataList();
    if (response.code === 1) {
      const data = response.result || response.data || [];
      
      // 提取前三名
      const top3 = data.slice(0, 3).map((item, index) => ({
        orderRank: item.orderRank ?? index + 1,
        studentName: item.studentName || '',
        studentAvatar: item.studentAvatar || 'https://appfile2.sbgw.cn/dcxcx/ac764c0802da4a29bb1526977c5c3084.png',
        gradeName: item.gradeName || '',
        progress: item.progress || 0,
        description: item.description || '',
      }));
      
      // 规范化字段，映射API返回的数据到模板需要的格式（从第4名开始）
      const listData = data.slice(3).map((item, index) => ({
        sort: item.orderRank ?? index + 4, // 排名（从第4名开始）
        studentName: item.studentName || '', // 学生姓名
        className: item.gradeName || '', // 班级名称
        progress: item.progress || 0, // 综合总分
        description: item.description || '', // 备注
        // 保留原始数据，方便后续使用
        studentId: item.studentId || 0,
        studentAvatar: item.studentAvatar || '',
        gradeId: item.gradeId || 0,
      }));
      
      // 保存前三名
      allStudentTop3.value = top3;
      
      // 保存原始数据（包含所有数据，用于重新分组）
      const normalized = data.map((item, index) => ({
        sort: item.orderRank ?? index + 1,
        studentName: item.studentName || '',
        className: item.gradeName || '',
        progress: item.progress || 0,
        description: item.description || '',
        studentId: item.studentId || 0,
        studentAvatar: item.studentAvatar || '',
        gradeId: item.gradeId || 0,
      }));
      allStudentRawData.value = normalized;
      
      // 按每页条数分组（列表数据从第4名开始）
      allStudentList.value = groupData(listData, comprehensiveRankItemsPerPage.value);
      
      // 重置轮播到第一页
      carouselStates.attendance.currentIndex.value = 0;
      if (carouselStates.attendance.ref.value) {
        carouselStates.attendance.ref.value.setActiveItem(0);
      }
    } else {
      allStudentList.value = [];
      allStudentRawData.value = [];
      allStudentTop3.value = [];
    }
  } catch (e) {
    console.error('获取综合学霸榜总榜数据失败:', e);
    allStudentList.value = [];
    allStudentRawData.value = [];
    allStudentTop3.value = [];
  }
};

// 获取作业达人榜数据
const fetchWorkExpertList = async (top, take = 30) => {
  try {
    const response = await GetWorkExpertList(top, take);
    if (response.code === 1) {
      const data = response.result || [];
      
      // 工具函数：分组
      const groupData = (data, groupSize) => {
        return data.reduce((result, item, index) => {
          const groupIndex = Math.floor(index / groupSize);
          if (!result[groupIndex]) {
            result[groupIndex] = [];
          }
          result[groupIndex].push(item);
          return result;
        }, []);
      };
      
      // 规范化字段
      const normalized = data.map((item, index) => ({
        rank: item.orderRanking ?? item.rank ?? index + 1,
        studentName: item.studentName || '',
        gradeName: item.gradeName || '',
        workSumbitPercent: item.workSumbitPercent ?? item.workSumbitPercent ?? 0, // 按时提交率
        scoreAvgPercent: item.scoreAvgPercent ?? item.scoreAvgPercent ?? 0, // 平均得分率
      }));
      // 保存原始并按当前每页条数分组
      workExpertRawData.value = normalized;
      workExpertList.value = groupData(normalized, workExpertItemsPerPage.value);
      
      // 重置轮播到第一页
      carouselStates.workExpert.currentIndex.value = 0;
      nextTick(() => {
        if (carouselStates.workExpert.ref.value) {
          carouselStates.workExpert.ref.value.setActiveItem(0);
        }
      });
    } else {
      workExpertList.value = [];
      // 重置轮播到第一页
      carouselStates.workExpert.currentIndex.value = 0;
      nextTick(() => {
        if (carouselStates.workExpert.ref.value) {
          carouselStates.workExpert.ref.value.setActiveItem(0);
        }
      });
    }
  } catch (e) {
    workExpertList.value = [];
    // 重置轮播到第一页
    carouselStates.workExpert.currentIndex.value = 0;
    nextTick(() => {
      if (carouselStates.workExpert.ref.value) {
        carouselStates.workExpert.ref.value.setActiveItem(0);
      }
    });
  }
};
const userAgentPublic = navigator.userAgent;
const mobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgentPublic.value);

// 根据窗口高度计算每列显示的条数
const calculateItemsPerColumn = () => {
  const windowHeight = window.innerHeight;
  const statusBarHeight = window.outerHeight - window.innerHeight;
  // 使用用户代理字符串检测设备
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  // >= 1000: 大屏模式
  // 680-990: 中等屏幕模式（接近920的情况）
  // < 680: 小屏模式（接近680或更小的情况）
  if(windowHeight >= 1200 ){
    studyCardHeight.value = 490; // 保留当前格局
    examCardHeight.value = 470; // 保留当前格局
    chartHeight.value = 35; 
    itemsPerColumn.value = 10; // 大屏维持10条一列
    examItemsPerPage.value = 10; // 线下考试大屏同样显示10条
    comprehensiveRankItemsPerPage.value = 7; // 综合学霸榜大屏同样显示7条
    workExpertItemsPerPage.value = 5; // 作业达人榜每页5条
    homeworkSubmitItemsPerPage.value = 5; // 课堂活跃达人榜大屏每页7条
    vocabularyItemsPerPage.value = 5; // 词汇量挑战榜大屏每页5条
    progressStarItemsPerPage.value = 10; // 进步之星大屏10条
    elCarouselHeight.value = 35;
    earlyArrivalCarouselHeight.value = 20;
    allStudentCarouselHeight.value = 26;
    isScreen.value = true;
  }else if (windowHeight >= 1000 && windowHeight < 1200) {
    itemsPerColumn.value = 10; // 大屏维持10条一列
    if(isMobile){
      studyCardHeight.value = 490; // 保留当前格局
      examCardHeight.value = 430; // 保留当前格局
      examItemsPerPage.value = 6; // 线下考试同样显示10条
      chartHeight.value = 32; 
      progressStarItemsPerPage.value = 4; // 进步之星6条
    }else{
      studyCardHeight.value = 490; // 保留当前格局
      examCardHeight.value = 470; // 保留当前格局
      chartHeight.value = 35; 
      examItemsPerPage.value = 10; // 线下考试同样显示10条
      progressStarItemsPerPage.value = 6; // 进步之星6条
    }
    comprehensiveRankItemsPerPage.value = 7; // 综合学霸榜同样显示7条
    workExpertItemsPerPage.value = 5; // 作业达人榜每页5条
    homeworkSubmitItemsPerPage.value = 5; // 课堂活跃达人榜每页7条
    vocabularyItemsPerPage.value = 5; // 词汇量挑战榜每页5条
    elCarouselHeight.value = 35;
    earlyArrivalCarouselHeight.value = 20;
    allStudentCarouselHeight.value = 26;
    isScreen.value = true;
  } else if (windowHeight >= 920 && windowHeight < 1000) {
    // 中等屏幕：880-919 范围
    if(statusBarHeight <= 78){
      studyCardHeight.value = 418;
    }else if(statusBarHeight > 78 && statusBarHeight <= 100){
      studyCardHeight.value = 408;
    }else {
      studyCardHeight.value = 393;
    }
    examCardHeight.value = 430;
    chartHeight.value = 35; 
    itemsPerColumn.value = 7;
    examItemsPerPage.value = 9; // 中等屏幕显示8条
    comprehensiveRankItemsPerPage.value = 4; // 综合学霸榜中等屏幕显示4条
    workExpertItemsPerPage.value = 4; // 作业达人榜每页4条
    homeworkSubmitItemsPerPage.value = 4; // 课堂活跃达人榜中等屏幕每页4条
    vocabularyItemsPerPage.value = 4; // 词汇量挑战榜中等屏幕每页4条
    progressStarItemsPerPage.value = 5; // 进步之星中等屏幕显示5条
    elCarouselHeight.value = 30;
    earlyArrivalCarouselHeight.value = 18;
    allStudentCarouselHeight.value = 19;
    isScreen.value = false;
  } else if (windowHeight >= 880 && windowHeight < 920) {
    // 中等屏幕：880-919 范围
    studyCardHeight.value = 378;
    examCardHeight.value = 430;
    chartHeight.value = 35; 
    itemsPerColumn.value = 7;
    examItemsPerPage.value = 9; // 中等屏幕显示9条
    comprehensiveRankItemsPerPage.value = 4; // 综合学霸榜中等屏幕显示4条
    workExpertItemsPerPage.value = 4; // 作业达人榜每页4条
    homeworkSubmitItemsPerPage.value = 4; // 课堂活跃达人榜中等屏幕每页4条
    vocabularyItemsPerPage.value = 4; // 词汇量挑战榜中等屏幕每页4条
    progressStarItemsPerPage.value = 5; // 进步之星中等屏幕显示5条
    elCarouselHeight.value = 30;
    earlyArrivalCarouselHeight.value = 18;
    allStudentCarouselHeight.value = 19;
    isScreen.value = false;
  } else {
    // 小屏模式：< 880
    studyCardHeight.value = 365;
    examCardHeight.value = 430;
    chartHeight.value = 32; 
    itemsPerColumn.value = 7;
    examItemsPerPage.value = 7; // 小屏显示7条
    comprehensiveRankItemsPerPage.value = 3; // 综合学霸榜小屏显示3条
    workExpertItemsPerPage.value = 4; // 作业达人榜每页4条
    homeworkSubmitItemsPerPage.value = 4; // 课堂活跃达人榜小屏每页4条
    vocabularyItemsPerPage.value = 4; // 词汇量挑战榜小屏每页4条
    progressStarItemsPerPage.value = 4; // 进步之星小屏显示4条
    elCarouselHeight.value = 25;
    earlyArrivalCarouselHeight.value = 15;
    allStudentCarouselHeight.value = 15;
    isScreen.value = false;
  }
  if(isMobile){
    studyCardHeight.value = 460; // 保留当前格局
    examCardHeight.value = 430; // 保留当前格局
    chartHeight.value = 32; 
    examItemsPerPage.value = 6; // 线下考试同样显示10条
    progressStarItemsPerPage.value = 4; // 进步之星6条
  }
};

// 根据itemsPerColumn重新分组学习坚持榜数据
const regroupStudyPersistenceData = () => {
  if (studyPersistenceRawData.value.length === 0) {
    attendanceRateList.value = [];
    earlyArrivalList.value = [];
    topStudentList.value = [];
    return;
  }
  
  // 按每页（左右两列总数）分组：每页 = itemsPerColumn * 2
  const itemsPerPage = itemsPerColumn.value * 2;
  
  const groupData = (data, groupSize) => {
    return data.reduce((result, item, index) => {
      const groupIndex = Math.floor(index / groupSize);
      if (!result[groupIndex]) {
        result[groupIndex] = [];
      }
      result[groupIndex].push(item);
      return result;
    }, []);
  };
  
  const allPages = groupData(studyPersistenceRawData.value, itemsPerPage);
  
  // 左边：每页的前 itemsPerColumn 条
  topStudentList.value = allPages.map(page => page.slice(0, itemsPerColumn.value));
  
  // 右边：每页的后 itemsPerColumn 条
  earlyArrivalList.value = allPages.map(page => page.slice(itemsPerColumn.value, itemsPerPage));
  
  // 保持attendanceRateList与topStudentList同步（用于其他地方的引用）
  attendanceRateList.value = topStudentList.value;
};

// 获取学习坚持榜数据
const fetchStudyPersistInData = async () => {
  const response = await GetStudyPersistIn();
  if (response.code === 1) {
    const data = response.result || [];
    
    // 规范化数据：统一格式，使用API返回的实际排名
    const normalizedData = data.map((item, index) => ({
      sort: item.orderRanking ?? (index + 1),
      studentName: item.studentName || '',
      className: item.gradeName || '',
      earlyMinutes: item.earlyMinutes || 0, // 早到时间（分钟）
    }));
    
    // 保存原始数据，用于重新分组
    studyPersistenceRawData.value = normalizedData;
    
    // 计算当前每列显示的条数
    calculateItemsPerColumn();
    
    // 重新分组数据
    regroupStudyPersistenceData();
  } else {
    studyPersistenceRawData.value = [];
    attendanceRateList.value = [];
    earlyArrivalList.value = [];
    topStudentList.value = [];
  }
};

// 获取今日寄语
const fetchAttendanceData = async (gradeIds = []) => {
  try {
    const response = await GetTopStudentInfo(gradeIds);
    if (response.code == 1) {
      // 将接口返回的数据转换为数组格式
      todayMessage.value = response.result.todayMessages || [];
      recentlyWorkNumber.value = response.result.recentlyWorkNumber;
      recentlyDayCourse.value = response.result.recentlyDayCourse;
      vocabularyChallengeDefaultDays.value = response.result.vocabularyChallengeDefaultDays;
    } else {
      // 如果接口返回为空，使用默认值
      todayMessage.value = [`全程先锋2班（光谷）寄语：付出努力的人，总能比别人走的更远，成就更大`];
      recentlyWorkNumber.value = 2;
      recentlyDayCourse.value = 7;
      vocabularyChallengeDefaultDays.value = 3;
    }
  } catch (error) {
    // 出错时使用默认值
    todayMessage.value = [`全程先锋2班（光谷）寄语：付出努力的人，总能比别人走的更远，成就更大`];
    recentlyWorkNumber.value = 2;
    recentlyDayCourse.value = 7;
    vocabularyChallengeDefaultDays.value = 3;
  }
  if(todayMessage.value?.length == 0){
    todayMessage.value = [`全程先锋2班（光谷）寄语：付出努力的人，总能比别人走的更远，成就更大`];
  }
};

// 获取早到进步之星数据
const fetchEarlyProgressData = async () => {
  const response = await GetTopStudetnReportEarlyList(33);
  if (response.code === 1) {
    const data = response.result || [];
    
    // 工具函数：分组
    const groupData = (data, groupSize) => {
      return data.reduce((result, item, index) => {
        const groupIndex = Math.floor(index / groupSize);
        if (!result[groupIndex]) {
          result[groupIndex] = [];
        }
        result[groupIndex].push(item);
        return result;
      }, []);
    };
    
    // 提取前三名
    const top3 = data.slice(0, 3).map((item, index) => ({
      orderRank: item.orderRank || index + 1,
      studentName: item.studentName || '',
      studentAvatar: item.studentAvatar || 'https://appfile2.sbgw.cn/dcxcx/ac764c0802da4a29bb1526977c5c3084.png',
      gradeName: item.gradeName || '',
      progress: item.progress || 0,
      description: item.description || '',
    }));
    
    // 处理列表数据（从第4名开始，因为前3名已经在顶部显示了）
    const listData = data.slice(3).map((item) => ({
      orderRank: item.orderRank || 0,
      studentName: item.studentName || '',
      className: item.gradeName || '',
      attendanceRate: item.progress || 0, // progress值作为"较上次上升名次"
      description: item.description || '',
    }));
    
    // 保存源数据，分组按进步之星每页数量
    earlyProgressTop3Src.value = top3;
    earlyProgressListSrc.value = groupData(listData, progressStarItemsPerPage.value);

    // 如果当前展示的是早到数据，则应用到展示容器
    if (currentProgressDataset.value === 'early') {
      earlyProgressTop3.value = earlyProgressTop3Src.value;
      earlyProgressList.value = earlyProgressListSrc.value;
      progressStarTitle.value = '早到进步之星';
    }
  } else {
    earlyProgressTop3Src.value = [];
    earlyProgressListSrc.value = [];
    if (currentProgressDataset.value === 'early') {
      earlyProgressTop3.value = [];
      earlyProgressList.value = [];
    }
  }
};

// 获取单词进步之星数据
const fetchWordProgressStarData = async () => {
  try {
    const res = await GetTopStudetnReportWordList(33);
    const data = (res?.data || res?.result || []);
    // 提取前三名
    const top3 = data.slice(0, 3).map((x, idx) => ({
      orderRank: x.orderRank ?? idx + 1,
      studentName: x.studentName ?? '',
      studentAvatar: x.studentAvatar ?? 'https://appfile2.sbgw.cn/dcxcx/ac764c0802da4a29bb1526977c5c3084.png',
      gradeName: x.gradeName ?? '',
      progress: x.progress ?? 0,
      description: x.description || '',
    }));
    const listData = data.slice(3).map(x => ({
      orderRank: x.orderRank ?? 0,
      studentName: x.studentName ?? '',
      className: x.gradeName ?? '',
      attendanceRate: x.progress ?? 0,
      description: x.description || '',
    }));
    // 源数据分组
    const group = (arr, size) => {
      const out = [];
      for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
      return out;
    };
    wordProgressTop3Src.value = top3;
    wordProgressListSrc.value = group(listData, progressStarItemsPerPage.value);

    if (currentProgressDataset.value === 'word') {
      // 如果当前展示的是单词数据，更新数据时需要重置轮播状态和标记
      earlyProgressTop3.value = wordProgressTop3Src.value;
      earlyProgressList.value = wordProgressListSrc.value;
      progressStarTitle.value = '单词进步之星';
      
      // 重置完整轮次标记，因为数据已更新
      progressDatasetCompleteRound.value = false;
      
      // 清除之前的定时器
      if (progressAutoSwitchTimer) {
        clearTimeout(progressAutoSwitchTimer);
        progressAutoSwitchTimer = null;
      }
      
      // 重置轮播到第一页
      carouselStates.earlyProgress.currentIndex.value = 0;
      nextTick(() => {
        if (carouselStates.earlyProgress.ref.value) {
          carouselStates.earlyProgress.ref.value.setActiveItem(0);
        }
      });
    }
  } catch (e) {
    wordProgressTop3Src.value = [];
    wordProgressListSrc.value = [];
    if (currentProgressDataset.value === 'word') {
      earlyProgressTop3.value = [];
      earlyProgressList.value = [];
    }
  }
};

// 获取作业进步之星数据
const fetchWorkProgressStarData = async () => {
  try {
    const res = await GetTopStudetnReportWorkList(33);
    const data = res?.result || [];
    const top3 = data.slice(0, 3).map((x, idx) => ({
      orderRank: x.orderRank ?? idx + 1,
      studentName: x.studentName || '',
      studentAvatar: x.studentAvatar || 'https://appfile2.sbgw.cn/dcxcx/ac764c0802da4a29bb1526977c5c3084.png',
      gradeName: x.gradeName || '',
      progress: x.progress || 0,
      description: x.description || '',
    }));
    const listData = data.slice(3).map(x => ({
      orderRank: x.orderRank ?? 0,
      studentName: x.studentName || '',
      className: x.gradeName || '',
      attendanceRate: x.progress || 0,
      description: x.description || '',
    }));
    const group = (arr, size) => {
      const out = [];
      for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
      return out;
    };
    workProgressTop3Src.value = top3;
    workProgressListSrc.value = group(listData, progressStarItemsPerPage.value);

    if (currentProgressDataset.value === 'work') {
      earlyProgressTop3.value = workProgressTop3Src.value;
      earlyProgressList.value = workProgressListSrc.value;
      progressStarTitle.value = '作业进步之星';
    }
  } catch (e) {
    workProgressTop3Src.value = [];
    workProgressListSrc.value = [];
    if (currentProgressDataset.value === 'work') {
      earlyProgressTop3.value = [];
      earlyProgressList.value = [];
    }
  }
};

// 获取考试进步之星数据
const fetchExamProgressStarData = async () => {
  try {
    const res = await GetTopStudetnReportExamList(33);
    const data = res?.result || [];
    
    // 提取前三名
    const top3 = data.slice(0, 3).map((x, idx) => ({
      orderRank: x.orderRank ?? idx + 1,
      studentName: x.studentName || '',
      studentAvatar: x.avatar || 'https://appfile2.sbgw.cn/dcxcx/ac764c0802da4a29bb1526977c5c3084.png',
      gradeName: x.gradeName || '',
      progress: x.progress || 0,
      description: x.description || '',
    }));
    
    // 处理列表数据（从第4名开始）
    const listData = data.slice(3).map(x => ({
      orderRank: x.orderRank ?? 0,
      studentName: x.studentName || '',
      className: x.gradeName || '',
      attendanceRate: x.progress || 0,
      description: x.description || '',
    }));
    
    // 分组函数
    const group = (arr, size) => {
      const out = [];
      for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
      return out;
    };
    
    examProgressTop3Src.value = top3;
    examProgressListSrc.value = group(listData, progressStarItemsPerPage.value);

    if (currentProgressDataset.value === 'exam') {
      earlyProgressTop3.value = examProgressTop3Src.value;
      earlyProgressList.value = examProgressListSrc.value;
      progressStarTitle.value = '考试进步之星';
    }
  } catch (e) {
    examProgressTop3Src.value = [];
    examProgressListSrc.value = [];
    if (currentProgressDataset.value === 'exam') {
      earlyProgressTop3.value = [];
      earlyProgressList.value = [];
    }
  }
};

// 获取课堂进步之星数据
const fetchCourseProgressStarData = async () => {
  try {
    const res = await GetTopStudetnReportCourseList(33);
    const data = res?.result || [];
    
    // 提取前三名
    const top3 = data.slice(0, 3).map((x, idx) => ({
      orderRank: x.orderRank ?? idx + 1,
      studentName: x.studentName || '',
      studentAvatar: x.studentAvatar || 'https://appfile2.sbgw.cn/dcxcx/ac764c0802da4a29bb1526977c5c3084.png',
      gradeName: x.gradeName || '',
      progress: x.progress || 0,
      description: x.description || '',
    }));
    
    // 处理列表数据（从第4名开始）
    const listData = data.slice(3).map(x => ({
      orderRank: x.orderRank ?? 0,
      studentName: x.studentName || '',
      className: x.gradeName || '',
      attendanceRate: x.progress || 0,
      description: x.description || '',
    }));
    
    // 分组函数
    const group = (arr, size) => {
      const out = [];
      for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
      return out;
    };
    
    courseProgressTop3Src.value = top3;
    courseProgressListSrc.value = group(listData, progressStarItemsPerPage.value);

    if (currentProgressDataset.value === 'course') {
      earlyProgressTop3.value = courseProgressTop3Src.value;
      earlyProgressList.value = courseProgressListSrc.value;
      progressStarTitle.value = '课堂进步之星';
    }
  } catch (e) {
    courseProgressTop3Src.value = [];
    courseProgressListSrc.value = [];
    if (currentProgressDataset.value === 'course') {
      earlyProgressTop3.value = [];
      earlyProgressList.value = [];
    }
  }
};

// 切换到指定索引的数据集（已废弃，保留兼容性）
const switchProgressDataset = (index) => {
  const available = availableProgressDatasets.value;
  if (index >= 0 && index < available.length) {
    currentProgressDataset.value = available[index];
    applyProgressDataset();
  }
};

// 根据数据集类型切换
const switchProgressDatasetByType = (datasetType) => {
  if (hasProgressData(datasetType)) {
    currentProgressDataset.value = datasetType;
    applyProgressDataset();
  }
};

// 切换到下一个数据集（自动切换使用）
const toggleProgressDataset = () => {
  // 只切换到有数据的数据集
  const available = availableProgressDatasets.value;
  if (available.length === 0) return;
  
  const currentIndex = available.indexOf(currentProgressDataset.value);
  const nextIndex = currentIndex >= 0 ? (currentIndex + 1) % available.length : 0;
  currentProgressDataset.value = available[nextIndex];
  applyProgressDataset();
};

// 应用当前数据集到展示容器
const applyProgressDataset = () => {
  // 清除之前的定时器
  if (progressAutoSwitchTimer) {
    clearTimeout(progressAutoSwitchTimer);
    progressAutoSwitchTimer = null;
  }
  
  // 如果当前数据集没有数据，切换到第一个有数据的数据集
  if (!hasProgressData(currentProgressDataset.value)) {
    const available = availableProgressDatasets.value;
    if (available.length > 0) {
      currentProgressDataset.value = available[0];
    } else {
      // 如果所有数据集都没有数据，清空显示
      earlyProgressTop3.value = [];
      earlyProgressList.value = [];
      progressStarTitle.value = '早到进步之星';
      return;
    }
  }
  
  // 重置完整轮次标记
  progressDatasetCompleteRound.value = false;
  
  if (currentProgressDataset.value === 'early') {
    earlyProgressTop3.value = earlyProgressTop3Src.value;
    earlyProgressList.value = earlyProgressListSrc.value;
    progressStarTitle.value = '早到进步之星';
  } else if (currentProgressDataset.value === 'word') {
    earlyProgressTop3.value = wordProgressTop3Src.value;
    earlyProgressList.value = wordProgressListSrc.value;
    progressStarTitle.value = '单词进步之星';
  } else if (currentProgressDataset.value === 'work') {
    earlyProgressTop3.value = workProgressTop3Src.value;
    earlyProgressList.value = workProgressListSrc.value;
    progressStarTitle.value = '作业进步之星';
  } else if (currentProgressDataset.value === 'exam') {
    earlyProgressTop3.value = examProgressTop3Src.value;
    earlyProgressList.value = examProgressListSrc.value;
    progressStarTitle.value = '考试进步之星';
  } else if (currentProgressDataset.value === 'course') {
    earlyProgressTop3.value = courseProgressTop3Src.value;
    earlyProgressList.value = courseProgressListSrc.value;
    progressStarTitle.value = '课堂进步之星';
  }
  // 重置到第一页
  carouselStates.earlyProgress.currentIndex.value = 0;
  // 使用 nextTick 确保 DOM 更新后再设置轮播
  nextTick(() => {
    carouselStates.earlyProgress.ref.value?.setActiveItem(0);
    // 如果数据只有一页或为空，设置自动切换定时器
    const pages = earlyProgressList.value.length;
    if (pages <= 1) {
      progressAutoSwitchTimer = setTimeout(() => {
        toggleProgressDataset();
        progressAutoSwitchTimer = null;
      }, 5000);
    }
  });
};

// 工具函数：分组
const groupExamData = (data, groupSize) => {
  const grouped = [];
  for (let i = 0; i < data.length; i += groupSize) {
    grouped.push(data.slice(i, i + groupSize));
  }
  return grouped;
};

// 获取线下考试相关数据
const fetchOfflineExamsData = async (gradeIds, yearId) => {
  const response = await GetOfflineExaminationAverageScoresV2(gradeIds, yearId);

  if (response.code === 1 && response.result) {
    const { offlineExaminationAverageScoreListDtos, offlineExamStatisticsResultDtos } = response.result;

    // 1. 填充图表数据
    if (offlineExaminationAverageScoreListDtos && offlineExaminationAverageScoreListDtos.length > 0) {
      offlineExamInationChartData.value.dates = offlineExaminationAverageScoreListDtos.map(item => item.reportName);
      offlineExamInationChartData.value.values = offlineExaminationAverageScoreListDtos.map(item => item.averageScore.toFixed(2));
    } else {
      offlineExamInationChartData.value.dates = [];
      offlineExamInationChartData.value.values = [];
    }
    initOfflineExamInationChart();

    // 2. 填充考试列表和排名
    if (offlineExamStatisticsResultDtos && offlineExamStatisticsResultDtos.length > 0) {
      currentYearExams.value = offlineExamStatisticsResultDtos.map(exam => ({
        id: offlineExaminationAverageScoreListDtos.find(e => e.reportName === exam.reportName)?.examinationID,
        title: exam.reportName,
      }));

      const allExamData = offlineExamStatisticsResultDtos.map(exam => {
        if (exam.offlineExamStatisticsSimpleDtos && exam.offlineExamStatisticsSimpleDtos.length > 0) {
          const dataList = exam.offlineExamStatisticsSimpleDtos.map((item, idx) => ({
            ...item,
            sort: idx + 1,
            // 确保字段映射正确：gradeName 用于班级名称，如果有 studentName 则使用
            gradeName: item.gradeName || item.className || '',
            averageScore: item.averageScore || 0,
          }));
          // 根据 examItemsPerPage 分组
          return groupExamData(dataList, examItemsPerPage.value);
        }
        return [];
      });
      examClassRankList.value = allExamData;
    } else {
      currentYearExams.value = [];
      examClassRankList.value = [];
    }
  } else {
    // 接口异常或无数据
    offlineExamInationChartData.value.dates = [];
    offlineExamInationChartData.value.values = [];
    initOfflineExamInationChart();
    currentYearExams.value = [];
    examClassRankList.value = [];
  }
};


// 获取年份数据并调用相关接口
const getYearData = async (yearId) => {
  const res = await GetNowYearGradeIds({ yearId });
  if (res.code === 1) {
    const gradeIds = res.result || []; // 获取班级ID数组
    fetchOfflineExamsData(gradeIds, yearId); // 获取考试信息
    fetchAttendanceData(gradeIds); // 获取今日寄语，传入班级ID
  } else {
    // 如果获取失败，使用默认值
    fetchOfflineExamsData([], yearId);
    fetchAttendanceData([]); // 获取今日寄语，传入空数组
  }
};

// 启动5分钟自动刷新
const startAutoRefresh = () => {
  // 清除之前的定时器
  if (autoRefreshTimer.value) {
    clearInterval(autoRefreshTimer.value);
  }
  
  // 设置5分钟（300000毫秒）定时器
  autoRefreshTimer.value = setInterval(async () => {
    fetchAttendanceData();// 获取今日寄语
    fetchStudyPersistInData();// 学习坚持榜
    await Promise.all([
      fetchEarlyProgressData(),// 早到进步之星
      fetchWordProgressStarData(),// 单词进步之星
      fetchWorkProgressStarData(),// 作业进步之星
      fetchExamProgressStarData(),// 考试进步之星
      fetchCourseProgressStarData(),// 课堂进步之星
    ]);
    // 所有进步之星数据刷新完成后，检查并切换到有数据的数据集
    nextTick(() => {
      applyProgressDataset();
    });
    
    fetchWorkExpertList();// 作业达人榜，使用默认值
    fetchHomeworkSubmitData();// 课堂活跃达人榜
    fetchAllStudentData(30);// 综合学霸榜总榜
    getTodayWeather();// 今日天气（会内部调用getYearData）
    // 同步刷新词汇量挑战榜，使用默认值
    fetchVocabularyChallenge(30);
  }, 5 * 60 * 1000); // 5分钟 = 300000毫秒
};

// 停止自动刷新
const stopAutoRefresh = () => {
  if (autoRefreshTimer.value) {
    clearInterval(autoRefreshTimer.value);
    autoRefreshTimer.value = null;
  }
};

onMounted(async() => {
    // 检查登录状态
    const isLogin = sessionStorage.getItem('isLogin');
    if (isLogin == 'false' || isLogin === null) {
      // 设置大屏标识
      sessionStorage.setItem('isLargeScreen', 'true');
      // 存储当前页面路径，用于登录后跳转回来
      sessionStorage.setItem('largeScreenPath', proxy.$route.fullPath);
      
      // 弹出提示框
      proxy.$confirm('请账号密码登录或钉钉扫码登录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        // 用户点击确定后跳转到登录页面
        proxy.$router.push('/');
      }).catch(() => {
        // 用户点击取消，清除大屏标识
      });
      return;
    }
  
  
  // 初始化计算每列显示的条数
  calculateItemsPerColumn();
  
  updateTime();
  fetchAttendanceData();// 获取今日寄语
  fetchStudyPersistInData();// 学习坚持榜
  await Promise.all([
    fetchEarlyProgressData(),// 早到进步之星
    fetchWordProgressStarData(),// 单词进步之星
    fetchWorkProgressStarData(),// 作业进步之星
    fetchExamProgressStarData(),// 考试进步之星
    fetchCourseProgressStarData(),// 课堂进步之星
  ]);
  // 所有进步之星数据加载完成后，检查并切换到有数据的数据集
  nextTick(() => {
    applyProgressDataset();
  });
  fetchWorkExpertList();// 作业达人榜，使用默认值
  fetchHomeworkSubmitData();// 课堂活跃达人榜
  fetchAllStudentData();// 综合学霸榜总榜
  await getTodayWeather();// 今日天气（会内部调用getYearData）
  fetchVocabularyChallenge(30);// 词汇量挑战榜，使用默认值
  window.addEventListener("resize", handleResize);
  startExamAutoSwitch();
  // 启动5分钟自动刷新
  startAutoRefresh();
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
  if (resizeTimer) clearTimeout(resizeTimer);
  offlineExamInationChart && offlineExamInationChart.dispose();
  clearTimeout(examAutoSwitchTimer); // 新增：清理定时器
  // 清理进步之星自动切换定时器
  if (progressAutoSwitchTimer) {
    clearTimeout(progressAutoSwitchTimer);
    progressAutoSwitchTimer = null;
  }
  // 清理今日寄语滚动定时器
  if (messageTimer.value) {
    clearInterval(messageTimer.value);
  }
  // 清理5分钟自动刷新定时器
  stopAutoRefresh();
  startScrolling();
});

// 确保数据分组逻辑正确
const groupData = (data, groupSize) => {
  const grouped = [];
  for (let i = 0; i < data.length; i += groupSize) {
    grouped.push(data.slice(i, i + groupSize));
  }
  return grouped;
};

const startScrolling = () => {
  const content = document.querySelector('.top-right-content');
  if (content) {
    const width = content.offsetWidth;
    content.style.animationDuration = `${width / 50}s`; // 滚动速度自适应内容长度
  }
};

watchEffect(() => {
  if (todayMessage.value.length > 0) {
    nextTick(startScrolling);
  }
});
// 缓存最近一次用于出勤统计的查询条件
const lastGradeIds = ref(null);
const lastNowTime = ref(null);
</script>

<style scoped lang="scss">
.body {
  width: 100vw;
  height: 100%;
  min-height: 0;
  background: #F5F4F0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
}

.top {
  position: relative;
  height: 7.5vh;
  min-height: 56px;
}

.top-left {
  position: absolute;
  top: 40%;
  left: 58px;
  transform: translateY(-50%);
  font-size: 16px;
  display: flex;
  align-items: center;

  .weather_img {
    width: 20px;
    height: 20px;
  }

  .weather_text {
    padding-left: 8px;
  }
}

.top-right {
  position: absolute;
  top: 40%;
  right: 0;
  transform: translateY(-50%);
  font-size: 16px;
  color: #333;
  display: flex;
  align-items: center;
  overflow: hidden;

  .msg_img{
    width: 20px;
    height: 20px;
  }

  .top-right-content-wrapper {
    display: flex;
    align-items: center;
    position: relative;
    width: 380px;
    height: 24px;
    overflow: hidden;
    margin-right: 30px;
  }

  .top-right-content {
    position: absolute;
    white-space: nowrap;
    padding-left: 8px;
    animation: scrollText 10s linear infinite; /* 10秒完成一次滚动，无限循环 */
  }

  .top-right-content ul {
    position: absolute;
    left: 0;
    top: -12px;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .top-right-content ul li {
    float: left;
    color: #333;
    font-size: 16px;
    margin-right: 15px;
  }
}

@keyframes scrollText {
  0% {
    transform: translateX(0%);
    opacity: 0;
    opacity: 1;
  }

  100% {
    transform: translateX(-100%);
    opacity: 1;
  }
}

.content {
  flex: 1 1 0;
  display: flex;
  height: 0;
  min-height: 0;
  padding: 0 1.7vh;
  padding-top: 18px;
  gap: 16px;

  .card {
    width: 100%;
    padding: 16px 24px;
    background-image: url("https://appfile2.sbgw.cn/hhsbzhxt/0a708bb41e07401a8440d68fb4be230a.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .integral-card{
    height: 89.9vh;
    background-color: #F9F9F9;
    background-size: 100% 100%;
    background-image: url("https://appfile2.sbgw.cn/hhsbzhxt/0feb681ddae7401a9a67b65ed12b7384.png") !important;
    background-repeat: no-repeat;
    padding: 16px 5px 16px 24px;
    margin-top: -0.5px;
  }

  .card-title {
    font-size: 24px;
    font-weight: bold;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    .card-title-right {
      margin-left: 16px;
      font-weight: 500;
      font-size: 12px;

      .number{
        margin-left: 4px;
        font-size: 16px;
        font-weight: 600;
      }
    }

    .subtitle {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
      color: #333;
      margin-bottom: 2px;
      margin-left: 10px;

      .subtitle-title {
        font-size: 16px;
        font-weight: 600;
      }

      .subtitle-text {
        font-size: 11px;
        color: #666;
      }
    }
  }

  .early-progress-title {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 14px;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .segmentation {
    width: 100%;
    margin-top: -22px;
  }

  .content-left {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    // align-items: center;
    width: 37.3%;

    .attendance {
      width: 100%;
      // height: 100%;
    }

    .attendance-rate {
      margin-top: 16px;

      .chart-title {
        font-size: 14px;
        font-weight: 600;
        color: #333;
        display: flex;
        justify-content: center;
      }
    }

    .offline-examination {
      // height: 100%;
      margin-bottom: 1.1%;
      position: relative;

      .offline-examination-left {
        width: 50%;
      }

      .offline-examination-right {
        width: 50%;
        height: 35vh;
      }

      .early-progress-title{
        font-weight: bold;
        font-size: 14px;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .chart-container {
        width: 100%;
        height: 100%;
      }
    }
  }

  .content-Middle {
    width: 28.1%;
  }

  .content-right {
    width: 32.2%;
  }

  .content-right-top{
    display: flex;
    justify-content: flex-end;
    font-size: 13px;
    font-weight: 400;
    color: #333;
    margin-top: -31px;
  }

  .content-right-top-item{
    min-width: 47px;
    height: 24px;
    background: #FAFAFA;
    border-radius: 4px;
    text-align: center;
    line-height: 24px;
    padding: 0 4px;
    box-sizing: border-box;
    margin-bottom: 8px;
  }

  .active{
    background: #FF6F0F;
    color: #FFFFFF;
    font-size: 12px;
    font-weight: 400;
  }

  .mr-16{
    margin-right: 14px;
  }

  .work-card{
    width: 100%;
    padding: 16px 24px;
    background-image: url("https://appfile2.sbgw.cn/hhsbzhxt/9b24bda9d8d04b089574b0ee00fb4ded.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-bottom: 12px;
    height: calc(100% / 3 - 12px);
    box-sizing: border-box;
    position: relative;
  }

  .attendance-left {
    width: 50%;
    min-height: 190px;
  }

  .mr-15{
    margin-right: 15px;
  }

  .mr-5{
    margin-right: 5px;
  }

  .attendance-right {
    width: 50%;
    min-height: 190px;
  }

  .all-rank{
    width: 100%;
    min-height: 190px;
  }

  .all-rank-cards{
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 18px;
  }
 
  .all-rank-item{
    width: 148px;
    height: 94px;
    /* 将渐变放到伪元素，避免影响内容不透明度 */
    background: none;
    border-radius: 8px 8px 0px 0px;
    margin: 0 auto;
    text-align: center;
    position: relative;
    margin-top: 26px;
  }

  .all-rank-item::before{
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 8px 8px 0px 0px;
    background: linear-gradient(180deg, #FFC832 0%, rgba(255,200,50,0) 100%);
    opacity: 0.2;
    z-index: 0;
  }

  /* 确保内容在背景之上显示 */
  .all-rank-item > * { position: relative; z-index: 1; }

  .all-rank-img1{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-top: -20px;
  }

  .all-rank-img2{
    width: 24px;
    height: 27px;
    position: absolute;
    top: 7px;
    left: 50%;
    transform: translateX(-50%);
  }

  /* 圆形奖牌（2、3名） */
  .medal{
    position: absolute;
    top: 26px;
    left: 50%;
    transform: translateX(-50%);
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 14px;
    color: #fff;
    box-shadow: 0 2px 4px rgba(0,0,0,0.08);
  }
  .medal-2{ background: #C9CDD4; border: 2px solid #BFC3CA; }
  .medal-3{ background: #E6A06A; border: 2px solid #D58B4C; }

  /* 居中卡片略突出 */
  .all-rank-item.first{ transform: translateY(-6px); }
  .all-rank-item.second, .all-rank-item.third{ transform: translateY(3px); }

  .all-rank-name{
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 12px;
    color: #333333;
    line-height: 17px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 16px;
  }

  .all-rank-class{
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 11px;
    color: #333333;
    line-height: 17px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: no-wrap;
  }

  .all-rank-score{
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 12px;
    color: #FF970F;
    line-height: 17px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }

  .table-title {
    display: flex;
    justify-content: flex-start;
    font-size: 14px;
    font-weight: 600;
  }

  .table-content {
    .table-header {
      padding: 0 16px;
      box-sizing: border-box;
      height: 3.2vh;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      background-color: #f5f4f0;
    }

    .table-header1{
      padding: 0 16px;
      box-sizing: border-box;
      height: 3.2vh;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      background-color: #f5f4f0;
    }

    .columns-style {
      background-color: #f5f4f0;
    }

    .table-row {
      height: 3.2vh;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      padding: 0 16px;
      box-sizing: border-box;
    }

    .table-row1{
      height: 3.2vh;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      padding: 0 16px;
    }

    .class-column {
      flex: 1;
      padding: 0 16px 0 0;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 0;
    }
    .class-column1 {
      flex: 1;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 0;
    }

    .rate-column,
    .count-column {
      width: 60px;
      text-align: right;
    }

    .count-column1{
      width: 108px;
      text-align: right;
    }

    .score-column {
      width: 48px;
      text-align: right;
    }

    .excess-column{
      text-align: left;
      width: 150px;
    }

    .number-of-excess-column {
      text-align: right;
      width: 75px;
    }

    .attendance-rate-column {
      text-align: right;
      min-width: 50px;
      flex-shrink: 0;
    }

    .class-column2{
      width: 100px;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

     .class-column3{
      width: 160px;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .progress-column{
      text-align: center;
      min-width: 75px;
      margin-right: 8px;
    }

    .progress-column1{
      text-align: right;
      min-width: 50px;
    }

    .all-score-column{
      text-align: right;
      min-width: 75px;
    }

    .description-column{
      text-align: left;
      width: 280px;
      flex-shrink: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .description-column1{
      display: flex;
      align-items: center;
      text-align: left;
      min-width: 245px;
      flex-shrink: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-left: 10px;

      .description-item{
        width: 31px;
        height: 19px;
        border-radius: 2px 2px 2px 2px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 19px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-right: 4px;
      }

      .description-item1{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 12px;
        height: 6px;
        border-radius: 1px 1px 1px 1px;
        margin-right: 4px;
        margin-top: 8px;
      }

      .mr-2{
        margin-right: 2px;
      }

      .description-item-text{
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        line-height: 17px;
        text-align: right;
        font-style: normal;
        text-transform: none;
        margin-top: 8px;
        margin-right: 16px;
      }

      .red_bar{
        background: #FF383C;
      }

      .orange_bar{
        background: #FF8D28;
      }

      .green_bar{
        background: #34C759;
      }
      
      .blue_bar{
        background: #0088FF;
      }

      .purple_bar{
        background: #6155F5;
      }
    }
  }
}

.integral-content {
  margin-top: -16px;
  .chart-title {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    display: block;
  }

  .chart-container {
    width: 100%;
  }

  .pie-chart {
    display: flex;
    flex-direction: column;
    align-items: center;

    .chart-container {
      height: 170px;
    }
  }

  .class-points {
    margin-top: 16px;

    > span {
      font-size: 14px;
      font-weight: 600;
      color: #333;
      display: block;
      margin-bottom: 12px;
    }

    .table-content {
      background: #f8f8f8;
      border-radius: 4px;
      padding: 8px 0px;
    }

    > div {
      display: flex;
      justify-content: space-between;
      gap: 16px;

      .class-points-left {
        width: 48%;

        span {
          font-size: 14px;
          font-weight: 600;
          color: #333;
          display: block;
        }
      }

      .class-points-right {
        width: 54%;
        margin-left: -5px;

        span {
          font-size: 14px;
          font-weight: 600;
          color: #333;
          display: block;
        }
      }
    }

    .chart-container {
      margin-top: 3.5vh;
      width: 100%;
      height: 11.4vh;
      background: #f8f8f8;
      border-radius: 4px;
    }
  }
}

.homework-submit-data {
  margin-top: -16px;
  min-height: 190px;
}

.word-learning-content {
  margin-top: -16px;

  .word-learning-top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;

    .word-learning-rankings {
      width: 60%;
      min-height: 191px;
    }

    .word-learning-trend {
      width: 50%;

      .section-title {
        font-size: 14px;
        font-weight: 600;
        color: #333;
        margin-bottom: 8px;
        display: block;
      }

      .chart-container {
        width: 100%;
        height: 126px;
        margin-top: 16px;
      }
    }
  }

  .word-learning-bottom {
    width: 100%;
    min-height: 191px;
  }

  .rank-section {
    .section-title {
      font-size: 14px;
      font-weight: 600;
      color: #333;
      margin-bottom: 8px;
      display: block;
    }
  }
}

.carousel-container {
  position: relative;
}

:deep(.el-carousel__container) {
  height: 100%;
}

.table-title-container {
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .carousel-indicators {
    display: flex;
    gap: 4px;

    .indicator {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #e5e5e5;
      cursor: pointer;
      // transition: all 0.3s;

      &.active {
        background: #ffa632;
      }

      &:hover {
        background: #ffa632;
      }
    }
  }
}

.table-title {
  font-size: 14px;
  font-weight: 600;
}

.title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}


.title-text{
  font-size: 14px;
  font-weight: 600;
  color: #333;
  line-height: 14px;
  margin-top: 5px;
  /* 多行省略号样式 */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  margin-right: 26px;
}

.table-row {
  display: flex;
  justify-content: space-between;
}

.echarts-tooltip-custom {
  width: 180px;
  height: 72px;
  background: black;
  border-radius: 6px 6px 6px 6px;
  margin: 8px;
}

.tooltip-title {
  color: #333;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 8px;
}

.echarts-tooltip-custom .tooltip-value {
  color: #ffa632;
  font-weight: bold;
  padding-left: 4px;
}

.calss-title {
  width: 100%;
  font-size: 12px !important;
}

:deep(.el-progress-bar__outer),
:deep(.el-progress-bar__inner) {
  border-radius: 0;
}

.nodata{
  margin-left: 40%;
  color: #bbb;
  font-size: 15px;
  font-weight: 600;
}

.attendance-card{
  margin-bottom: 8px;
  background-size: 100% 100% !important;
  position: relative;
}

.card-title-line{
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 386px;
  height: 2px;
  background: linear-gradient( 90deg, rgba(255,151,15,0) 0%, #FF970F 50%, rgba(255,151,15,0) 100%);
  border-radius: 0px 0px 0px 0px;
}

.card-tip-text{
  color: #999;
  font-size: 12px;
  font-weight: 400;
  margin-left: 2px;
}

.card-tip-img{
  width: 24px;
  height: 24px;
  margin-top: -4px;
}

.rank-column{
  width: 24px;
  min-width: 24px;
  flex-shrink: 0;
  text-align: center;
  margin-right: 16px;
}

.name-column{
    width: 64px;
    min-width: 64px;
    flex-shrink: 0;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 8px;
}

.name-column1{
  width: 64px;
  min-width: 64px;
  flex-shrink: 0;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rank-img{
    width: 24px;
    height: 27px;
}

// 骨架屏样式
.skeleton {
  // background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  // animation: skeleton-loading 5.5s ease-in-out infinite;
  border-radius: 4px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-item {
  .skeleton-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin: -20px auto 0;
    position: relative;
    z-index: 1;
  }

  .skeleton-medal {
    width: 24px;
    height: 27px;
    position: absolute;
    top: 7px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
  }

  .skeleton-name {
    width: 60px;
    height: 12px;
    margin: 16px auto 0;
    z-index: 1;
    position: relative;
  }

  .skeleton-class {
    width: 100px;
    height: 11px;
    margin: 4px auto 0;
    z-index: 1;
    position: relative;
  }

  .skeleton-score {
    width: 40px;
    height: 12px;
    margin: 4px auto 0;
    z-index: 1;
    position: relative;
  }
}

.skeleton-text {
  height: 12px;
  width: 60%;
  margin: 0 auto;
}
</style>
